import { r as registerInstance, d as createEvent, c as getElement, h } from './index-34617187.js';
import * as _ from 'lodash-es';
import { B as BxfTabBarDeletableTypeEnum } from './bxf-tab-bar-deletable-type.enum-ff783baa.js';
import { B as BxfTabBarConstants } from './bxf-tab-bar.constants-fa15fe27.js';
import { F as FocusSource } from './focus-source.enum-fe7089b3.js';
import { B as BxfButtonTypeEnum } from './button-type.enum-3452e5b6.js';
import { i as isUsingI18n, B as BxfI18n, t as translateKeys } from './i18n.config-355137b0.js';
import { K as KeyboardEventKey } from './keyboard-event-key.enum-2f6c4d91.js';
import { Q as eventPath, w as getKeyboardFocusCSS, l as createSelector } from './bxf-utils-3908c3c5.js';
import { F as FocusIndexManager } from './focus-index-manager-d376b5ea.js';
import { R as Role } from './role.enum-c3c8cd89.js';
import 'dompurify';

/**!
 * Sortable 1.15.6
 * @author	RubaXa   <trash@rubaxa.org>
 * @author	owenm    <owen23355@gmail.com>
 * @license MIT
 */
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}

var version = "1.15.6";

function userAgent(pattern) {
  if (typeof window !== 'undefined' && window.navigator) {
    return !! /*@__PURE__*/navigator.userAgent.match(pattern);
  }
}
var IE11OrLess = userAgent(/(?:Trident.*rv[ :]?11\.|msie|iemobile|Windows Phone)/i);
var Edge = userAgent(/Edge/i);
var FireFox = userAgent(/firefox/i);
var Safari = userAgent(/safari/i) && !userAgent(/chrome/i) && !userAgent(/android/i);
var IOS = userAgent(/iP(ad|od|hone)/i);
var ChromeForAndroid = userAgent(/chrome/i) && userAgent(/android/i);

var captureMode = {
  capture: false,
  passive: false
};
function on(el, event, fn) {
  el.addEventListener(event, fn, !IE11OrLess && captureMode);
}
function off(el, event, fn) {
  el.removeEventListener(event, fn, !IE11OrLess && captureMode);
}
function matches( /**HTMLElement*/el, /**String*/selector) {
  if (!selector) return;
  selector[0] === '>' && (selector = selector.substring(1));
  if (el) {
    try {
      if (el.matches) {
        return el.matches(selector);
      } else if (el.msMatchesSelector) {
        return el.msMatchesSelector(selector);
      } else if (el.webkitMatchesSelector) {
        return el.webkitMatchesSelector(selector);
      }
    } catch (_) {
      return false;
    }
  }
  return false;
}
function getParentOrHost(el) {
  return el.host && el !== document && el.host.nodeType ? el.host : el.parentNode;
}
function closest( /**HTMLElement*/el, /**String*/selector, /**HTMLElement*/ctx, includeCTX) {
  if (el) {
    ctx = ctx || document;
    do {
      if (selector != null && (selector[0] === '>' ? el.parentNode === ctx && matches(el, selector) : matches(el, selector)) || includeCTX && el === ctx) {
        return el;
      }
      if (el === ctx) break;
      /* jshint boss:true */
    } while (el = getParentOrHost(el));
  }
  return null;
}
var R_SPACE = /\s+/g;
function toggleClass(el, name, state) {
  if (el && name) {
    if (el.classList) {
      el.classList[state ? 'add' : 'remove'](name);
    } else {
      var className = (' ' + el.className + ' ').replace(R_SPACE, ' ').replace(' ' + name + ' ', ' ');
      el.className = (className + (state ? ' ' + name : '')).replace(R_SPACE, ' ');
    }
  }
}
function css(el, prop, val) {
  var style = el && el.style;
  if (style) {
    if (val === void 0) {
      if (document.defaultView && document.defaultView.getComputedStyle) {
        val = document.defaultView.getComputedStyle(el, '');
      } else if (el.currentStyle) {
        val = el.currentStyle;
      }
      return prop === void 0 ? val : val[prop];
    } else {
      if (!(prop in style) && prop.indexOf('webkit') === -1) {
        prop = '-webkit-' + prop;
      }
      style[prop] = val + (typeof val === 'string' ? '' : 'px');
    }
  }
}
function matrix(el, selfOnly) {
  var appliedTransforms = '';
  if (typeof el === 'string') {
    appliedTransforms = el;
  } else {
    do {
      var transform = css(el, 'transform');
      if (transform && transform !== 'none') {
        appliedTransforms = transform + ' ' + appliedTransforms;
      }
      /* jshint boss:true */
    } while (!selfOnly && (el = el.parentNode));
  }
  var matrixFn = window.DOMMatrix || window.WebKitCSSMatrix || window.CSSMatrix || window.MSCSSMatrix;
  /*jshint -W056 */
  return matrixFn && new matrixFn(appliedTransforms);
}
function find(ctx, tagName, iterator) {
  if (ctx) {
    var list = ctx.getElementsByTagName(tagName),
      i = 0,
      n = list.length;
    if (iterator) {
      for (; i < n; i++) {
        iterator(list[i], i);
      }
    }
    return list;
  }
  return [];
}
function getWindowScrollingElement() {
  var scrollingElement = document.scrollingElement;
  if (scrollingElement) {
    return scrollingElement;
  } else {
    return document.documentElement;
  }
}

/**
 * Returns the "bounding client rect" of given element
 * @param  {HTMLElement} el                       The element whose boundingClientRect is wanted
 * @param  {[Boolean]} relativeToContainingBlock  Whether the rect should be relative to the containing block of (including) the container
 * @param  {[Boolean]} relativeToNonStaticParent  Whether the rect should be relative to the relative parent of (including) the contaienr
 * @param  {[Boolean]} undoScale                  Whether the container's scale() should be undone
 * @param  {[HTMLElement]} container              The parent the element will be placed in
 * @return {Object}                               The boundingClientRect of el, with specified adjustments
 */
function getRect(el, relativeToContainingBlock, relativeToNonStaticParent, undoScale, container) {
  if (!el.getBoundingClientRect && el !== window) return;
  var elRect, top, left, bottom, right, height, width;
  if (el !== window && el.parentNode && el !== getWindowScrollingElement()) {
    elRect = el.getBoundingClientRect();
    top = elRect.top;
    left = elRect.left;
    bottom = elRect.bottom;
    right = elRect.right;
    height = elRect.height;
    width = elRect.width;
  } else {
    top = 0;
    left = 0;
    bottom = window.innerHeight;
    right = window.innerWidth;
    height = window.innerHeight;
    width = window.innerWidth;
  }
  if ((relativeToContainingBlock || relativeToNonStaticParent) && el !== window) {
    // Adjust for translate()
    container = container || el.parentNode;

    // solves #1123 (see: https://stackoverflow.com/a/37953806/6088312)
    // Not needed on <= IE11
    if (!IE11OrLess) {
      do {
        if (container && container.getBoundingClientRect && (css(container, 'transform') !== 'none' || relativeToNonStaticParent && css(container, 'position') !== 'static')) {
          var containerRect = container.getBoundingClientRect();

          // Set relative to edges of padding box of container
          top -= containerRect.top + parseInt(css(container, 'border-top-width'));
          left -= containerRect.left + parseInt(css(container, 'border-left-width'));
          bottom = top + elRect.height;
          right = left + elRect.width;
          break;
        }
        /* jshint boss:true */
      } while (container = container.parentNode);
    }
  }
  if (undoScale && el !== window) {
    // Adjust for scale()
    var elMatrix = matrix(container || el),
      scaleX = elMatrix && elMatrix.a,
      scaleY = elMatrix && elMatrix.d;
    if (elMatrix) {
      top /= scaleY;
      left /= scaleX;
      width /= scaleX;
      height /= scaleY;
      bottom = top + height;
      right = left + width;
    }
  }
  return {
    top: top,
    left: left,
    bottom: bottom,
    right: right,
    width: width,
    height: height
  };
}

/**
 * Checks if a side of an element is scrolled past a side of its parents
 * @param  {HTMLElement}  el           The element who's side being scrolled out of view is in question
 * @param  {String}       elSide       Side of the element in question ('top', 'left', 'right', 'bottom')
 * @param  {String}       parentSide   Side of the parent in question ('top', 'left', 'right', 'bottom')
 * @return {HTMLElement}               The parent scroll element that the el's side is scrolled past, or null if there is no such element
 */
function isScrolledPast(el, elSide, parentSide) {
  var parent = getParentAutoScrollElement(el, true),
    elSideVal = getRect(el)[elSide];

  /* jshint boss:true */
  while (parent) {
    var parentSideVal = getRect(parent)[parentSide],
      visible = void 0;
    if (parentSide === 'top' || parentSide === 'left') {
      visible = elSideVal >= parentSideVal;
    } else {
      visible = elSideVal <= parentSideVal;
    }
    if (!visible) return parent;
    if (parent === getWindowScrollingElement()) break;
    parent = getParentAutoScrollElement(parent, false);
  }
  return false;
}

/**
 * Gets nth child of el, ignoring hidden children, sortable's elements (does not ignore clone if it's visible)
 * and non-draggable elements
 * @param  {HTMLElement} el       The parent element
 * @param  {Number} childNum      The index of the child
 * @param  {Object} options       Parent Sortable's options
 * @return {HTMLElement}          The child at index childNum, or null if not found
 */
function getChild(el, childNum, options, includeDragEl) {
  var currentChild = 0,
    i = 0,
    children = el.children;
  while (i < children.length) {
    if (children[i].style.display !== 'none' && children[i] !== Sortable.ghost && (includeDragEl || children[i] !== Sortable.dragged) && closest(children[i], options.draggable, el, false)) {
      if (currentChild === childNum) {
        return children[i];
      }
      currentChild++;
    }
    i++;
  }
  return null;
}

/**
 * Gets the last child in the el, ignoring ghostEl or invisible elements (clones)
 * @param  {HTMLElement} el       Parent element
 * @param  {selector} selector    Any other elements that should be ignored
 * @return {HTMLElement}          The last child, ignoring ghostEl
 */
function lastChild(el, selector) {
  var last = el.lastElementChild;
  while (last && (last === Sortable.ghost || css(last, 'display') === 'none' || selector && !matches(last, selector))) {
    last = last.previousElementSibling;
  }
  return last || null;
}

/**
 * Returns the index of an element within its parent for a selected set of
 * elements
 * @param  {HTMLElement} el
 * @param  {selector} selector
 * @return {number}
 */
function index(el, selector) {
  var index = 0;
  if (!el || !el.parentNode) {
    return -1;
  }

  /* jshint boss:true */
  while (el = el.previousElementSibling) {
    if (el.nodeName.toUpperCase() !== 'TEMPLATE' && el !== Sortable.clone && (!selector || matches(el, selector))) {
      index++;
    }
  }
  return index;
}

/**
 * Returns the scroll offset of the given element, added with all the scroll offsets of parent elements.
 * The value is returned in real pixels.
 * @param  {HTMLElement} el
 * @return {Array}             Offsets in the format of [left, top]
 */
function getRelativeScrollOffset(el) {
  var offsetLeft = 0,
    offsetTop = 0,
    winScroller = getWindowScrollingElement();
  if (el) {
    do {
      var elMatrix = matrix(el),
        scaleX = elMatrix.a,
        scaleY = elMatrix.d;
      offsetLeft += el.scrollLeft * scaleX;
      offsetTop += el.scrollTop * scaleY;
    } while (el !== winScroller && (el = el.parentNode));
  }
  return [offsetLeft, offsetTop];
}

/**
 * Returns the index of the object within the given array
 * @param  {Array} arr   Array that may or may not hold the object
 * @param  {Object} obj  An object that has a key-value pair unique to and identical to a key-value pair in the object you want to find
 * @return {Number}      The index of the object in the array, or -1
 */
function indexOfObject(arr, obj) {
  for (var i in arr) {
    if (!arr.hasOwnProperty(i)) continue;
    for (var key in obj) {
      if (obj.hasOwnProperty(key) && obj[key] === arr[i][key]) return Number(i);
    }
  }
  return -1;
}
function getParentAutoScrollElement(el, includeSelf) {
  // skip to window
  if (!el || !el.getBoundingClientRect) return getWindowScrollingElement();
  var elem = el;
  var gotSelf = false;
  do {
    // we don't need to get elem css if it isn't even overflowing in the first place (performance)
    if (elem.clientWidth < elem.scrollWidth || elem.clientHeight < elem.scrollHeight) {
      var elemCSS = css(elem);
      if (elem.clientWidth < elem.scrollWidth && (elemCSS.overflowX == 'auto' || elemCSS.overflowX == 'scroll') || elem.clientHeight < elem.scrollHeight && (elemCSS.overflowY == 'auto' || elemCSS.overflowY == 'scroll')) {
        if (!elem.getBoundingClientRect || elem === document.body) return getWindowScrollingElement();
        if (gotSelf || includeSelf) return elem;
        gotSelf = true;
      }
    }
    /* jshint boss:true */
  } while (elem = elem.parentNode);
  return getWindowScrollingElement();
}
function extend(dst, src) {
  if (dst && src) {
    for (var key in src) {
      if (src.hasOwnProperty(key)) {
        dst[key] = src[key];
      }
    }
  }
  return dst;
}
function isRectEqual(rect1, rect2) {
  return Math.round(rect1.top) === Math.round(rect2.top) && Math.round(rect1.left) === Math.round(rect2.left) && Math.round(rect1.height) === Math.round(rect2.height) && Math.round(rect1.width) === Math.round(rect2.width);
}
var _throttleTimeout;
function throttle(callback, ms) {
  return function () {
    if (!_throttleTimeout) {
      var args = arguments,
        _this = this;
      if (args.length === 1) {
        callback.call(_this, args[0]);
      } else {
        callback.apply(_this, args);
      }
      _throttleTimeout = setTimeout(function () {
        _throttleTimeout = void 0;
      }, ms);
    }
  };
}
function scrollBy(el, x, y) {
  el.scrollLeft += x;
  el.scrollTop += y;
}
function clone(el) {
  var Polymer = window.Polymer;
  var $ = window.jQuery || window.Zepto;
  if (Polymer && Polymer.dom) {
    return Polymer.dom(el).cloneNode(true);
  } else if ($) {
    return $(el).clone(true)[0];
  } else {
    return el.cloneNode(true);
  }
}
function getChildContainingRectFromElement(container, options, ghostEl) {
  var rect = {};
  Array.from(container.children).forEach(function (child) {
    var _rect$left, _rect$top, _rect$right, _rect$bottom;
    if (!closest(child, options.draggable, container, false) || child.animated || child === ghostEl) return;
    var childRect = getRect(child);
    rect.left = Math.min((_rect$left = rect.left) !== null && _rect$left !== void 0 ? _rect$left : Infinity, childRect.left);
    rect.top = Math.min((_rect$top = rect.top) !== null && _rect$top !== void 0 ? _rect$top : Infinity, childRect.top);
    rect.right = Math.max((_rect$right = rect.right) !== null && _rect$right !== void 0 ? _rect$right : -Infinity, childRect.right);
    rect.bottom = Math.max((_rect$bottom = rect.bottom) !== null && _rect$bottom !== void 0 ? _rect$bottom : -Infinity, childRect.bottom);
  });
  rect.width = rect.right - rect.left;
  rect.height = rect.bottom - rect.top;
  rect.x = rect.left;
  rect.y = rect.top;
  return rect;
}
var expando = 'Sortable' + new Date().getTime();

function AnimationStateManager() {
  var animationStates = [],
    animationCallbackId;
  return {
    captureAnimationState: function captureAnimationState() {
      animationStates = [];
      if (!this.options.animation) return;
      var children = [].slice.call(this.el.children);
      children.forEach(function (child) {
        if (css(child, 'display') === 'none' || child === Sortable.ghost) return;
        animationStates.push({
          target: child,
          rect: getRect(child)
        });
        var fromRect = _objectSpread2({}, animationStates[animationStates.length - 1].rect);

        // If animating: compensate for current animation
        if (child.thisAnimationDuration) {
          var childMatrix = matrix(child, true);
          if (childMatrix) {
            fromRect.top -= childMatrix.f;
            fromRect.left -= childMatrix.e;
          }
        }
        child.fromRect = fromRect;
      });
    },
    addAnimationState: function addAnimationState(state) {
      animationStates.push(state);
    },
    removeAnimationState: function removeAnimationState(target) {
      animationStates.splice(indexOfObject(animationStates, {
        target: target
      }), 1);
    },
    animateAll: function animateAll(callback) {
      var _this = this;
      if (!this.options.animation) {
        clearTimeout(animationCallbackId);
        if (typeof callback === 'function') callback();
        return;
      }
      var animating = false,
        animationTime = 0;
      animationStates.forEach(function (state) {
        var time = 0,
          target = state.target,
          fromRect = target.fromRect,
          toRect = getRect(target),
          prevFromRect = target.prevFromRect,
          prevToRect = target.prevToRect,
          animatingRect = state.rect,
          targetMatrix = matrix(target, true);
        if (targetMatrix) {
          // Compensate for current animation
          toRect.top -= targetMatrix.f;
          toRect.left -= targetMatrix.e;
        }
        target.toRect = toRect;
        if (target.thisAnimationDuration) {
          // Could also check if animatingRect is between fromRect and toRect
          if (isRectEqual(prevFromRect, toRect) && !isRectEqual(fromRect, toRect) &&
          // Make sure animatingRect is on line between toRect & fromRect
          (animatingRect.top - toRect.top) / (animatingRect.left - toRect.left) === (fromRect.top - toRect.top) / (fromRect.left - toRect.left)) {
            // If returning to same place as started from animation and on same axis
            time = calculateRealTime(animatingRect, prevFromRect, prevToRect, _this.options);
          }
        }

        // if fromRect != toRect: animate
        if (!isRectEqual(toRect, fromRect)) {
          target.prevFromRect = fromRect;
          target.prevToRect = toRect;
          if (!time) {
            time = _this.options.animation;
          }
          _this.animate(target, animatingRect, toRect, time);
        }
        if (time) {
          animating = true;
          animationTime = Math.max(animationTime, time);
          clearTimeout(target.animationResetTimer);
          target.animationResetTimer = setTimeout(function () {
            target.animationTime = 0;
            target.prevFromRect = null;
            target.fromRect = null;
            target.prevToRect = null;
            target.thisAnimationDuration = null;
          }, time);
          target.thisAnimationDuration = time;
        }
      });
      clearTimeout(animationCallbackId);
      if (!animating) {
        if (typeof callback === 'function') callback();
      } else {
        animationCallbackId = setTimeout(function () {
          if (typeof callback === 'function') callback();
        }, animationTime);
      }
      animationStates = [];
    },
    animate: function animate(target, currentRect, toRect, duration) {
      if (duration) {
        css(target, 'transition', '');
        css(target, 'transform', '');
        var elMatrix = matrix(this.el),
          scaleX = elMatrix && elMatrix.a,
          scaleY = elMatrix && elMatrix.d,
          translateX = (currentRect.left - toRect.left) / (scaleX || 1),
          translateY = (currentRect.top - toRect.top) / (scaleY || 1);
        target.animatingX = !!translateX;
        target.animatingY = !!translateY;
        css(target, 'transform', 'translate3d(' + translateX + 'px,' + translateY + 'px,0)');
        this.forRepaintDummy = repaint(target); // repaint

        css(target, 'transition', 'transform ' + duration + 'ms' + (this.options.easing ? ' ' + this.options.easing : ''));
        css(target, 'transform', 'translate3d(0,0,0)');
        typeof target.animated === 'number' && clearTimeout(target.animated);
        target.animated = setTimeout(function () {
          css(target, 'transition', '');
          css(target, 'transform', '');
          target.animated = false;
          target.animatingX = false;
          target.animatingY = false;
        }, duration);
      }
    }
  };
}
function repaint(target) {
  return target.offsetWidth;
}
function calculateRealTime(animatingRect, fromRect, toRect, options) {
  return Math.sqrt(Math.pow(fromRect.top - animatingRect.top, 2) + Math.pow(fromRect.left - animatingRect.left, 2)) / Math.sqrt(Math.pow(fromRect.top - toRect.top, 2) + Math.pow(fromRect.left - toRect.left, 2)) * options.animation;
}

var plugins = [];
var defaults = {
  initializeByDefault: true
};
var PluginManager = {
  mount: function mount(plugin) {
    // Set default static properties
    for (var option in defaults) {
      if (defaults.hasOwnProperty(option) && !(option in plugin)) {
        plugin[option] = defaults[option];
      }
    }
    plugins.forEach(function (p) {
      if (p.pluginName === plugin.pluginName) {
        throw "Sortable: Cannot mount plugin ".concat(plugin.pluginName, " more than once");
      }
    });
    plugins.push(plugin);
  },
  pluginEvent: function pluginEvent(eventName, sortable, evt) {
    var _this = this;
    this.eventCanceled = false;
    evt.cancel = function () {
      _this.eventCanceled = true;
    };
    var eventNameGlobal = eventName + 'Global';
    plugins.forEach(function (plugin) {
      if (!sortable[plugin.pluginName]) return;
      // Fire global events if it exists in this sortable
      if (sortable[plugin.pluginName][eventNameGlobal]) {
        sortable[plugin.pluginName][eventNameGlobal](_objectSpread2({
          sortable: sortable
        }, evt));
      }

      // Only fire plugin event if plugin is enabled in this sortable,
      // and plugin has event defined
      if (sortable.options[plugin.pluginName] && sortable[plugin.pluginName][eventName]) {
        sortable[plugin.pluginName][eventName](_objectSpread2({
          sortable: sortable
        }, evt));
      }
    });
  },
  initializePlugins: function initializePlugins(sortable, el, defaults, options) {
    plugins.forEach(function (plugin) {
      var pluginName = plugin.pluginName;
      if (!sortable.options[pluginName] && !plugin.initializeByDefault) return;
      var initialized = new plugin(sortable, el, sortable.options);
      initialized.sortable = sortable;
      initialized.options = sortable.options;
      sortable[pluginName] = initialized;

      // Add default options from plugin
      _extends(defaults, initialized.defaults);
    });
    for (var option in sortable.options) {
      if (!sortable.options.hasOwnProperty(option)) continue;
      var modified = this.modifyOption(sortable, option, sortable.options[option]);
      if (typeof modified !== 'undefined') {
        sortable.options[option] = modified;
      }
    }
  },
  getEventProperties: function getEventProperties(name, sortable) {
    var eventProperties = {};
    plugins.forEach(function (plugin) {
      if (typeof plugin.eventProperties !== 'function') return;
      _extends(eventProperties, plugin.eventProperties.call(sortable[plugin.pluginName], name));
    });
    return eventProperties;
  },
  modifyOption: function modifyOption(sortable, name, value) {
    var modifiedValue;
    plugins.forEach(function (plugin) {
      // Plugin must exist on the Sortable
      if (!sortable[plugin.pluginName]) return;

      // If static option listener exists for this option, call in the context of the Sortable's instance of this plugin
      if (plugin.optionListeners && typeof plugin.optionListeners[name] === 'function') {
        modifiedValue = plugin.optionListeners[name].call(sortable[plugin.pluginName], value);
      }
    });
    return modifiedValue;
  }
};

function dispatchEvent(_ref) {
  var sortable = _ref.sortable,
    rootEl = _ref.rootEl,
    name = _ref.name,
    targetEl = _ref.targetEl,
    cloneEl = _ref.cloneEl,
    toEl = _ref.toEl,
    fromEl = _ref.fromEl,
    oldIndex = _ref.oldIndex,
    newIndex = _ref.newIndex,
    oldDraggableIndex = _ref.oldDraggableIndex,
    newDraggableIndex = _ref.newDraggableIndex,
    originalEvent = _ref.originalEvent,
    putSortable = _ref.putSortable,
    extraEventProperties = _ref.extraEventProperties;
  sortable = sortable || rootEl && rootEl[expando];
  if (!sortable) return;
  var evt,
    options = sortable.options,
    onName = 'on' + name.charAt(0).toUpperCase() + name.substr(1);
  // Support for new CustomEvent feature
  if (window.CustomEvent && !IE11OrLess && !Edge) {
    evt = new CustomEvent(name, {
      bubbles: true,
      cancelable: true
    });
  } else {
    evt = document.createEvent('Event');
    evt.initEvent(name, true, true);
  }
  evt.to = toEl || rootEl;
  evt.from = fromEl || rootEl;
  evt.item = targetEl || rootEl;
  evt.clone = cloneEl;
  evt.oldIndex = oldIndex;
  evt.newIndex = newIndex;
  evt.oldDraggableIndex = oldDraggableIndex;
  evt.newDraggableIndex = newDraggableIndex;
  evt.originalEvent = originalEvent;
  evt.pullMode = putSortable ? putSortable.lastPutMode : undefined;
  var allEventProperties = _objectSpread2(_objectSpread2({}, extraEventProperties), PluginManager.getEventProperties(name, sortable));
  for (var option in allEventProperties) {
    evt[option] = allEventProperties[option];
  }
  if (rootEl) {
    rootEl.dispatchEvent(evt);
  }
  if (options[onName]) {
    options[onName].call(sortable, evt);
  }
}

var _excluded = ["evt"];
var pluginEvent = function pluginEvent(eventName, sortable) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
    originalEvent = _ref.evt,
    data = _objectWithoutProperties(_ref, _excluded);
  PluginManager.pluginEvent.bind(Sortable)(eventName, sortable, _objectSpread2({
    dragEl: dragEl,
    parentEl: parentEl,
    ghostEl: ghostEl,
    rootEl: rootEl,
    nextEl: nextEl,
    lastDownEl: lastDownEl,
    cloneEl: cloneEl,
    cloneHidden: cloneHidden,
    dragStarted: moved,
    putSortable: putSortable,
    activeSortable: Sortable.active,
    originalEvent: originalEvent,
    oldIndex: oldIndex,
    oldDraggableIndex: oldDraggableIndex,
    newIndex: newIndex,
    newDraggableIndex: newDraggableIndex,
    hideGhostForTarget: _hideGhostForTarget,
    unhideGhostForTarget: _unhideGhostForTarget,
    cloneNowHidden: function cloneNowHidden() {
      cloneHidden = true;
    },
    cloneNowShown: function cloneNowShown() {
      cloneHidden = false;
    },
    dispatchSortableEvent: function dispatchSortableEvent(name) {
      _dispatchEvent({
        sortable: sortable,
        name: name,
        originalEvent: originalEvent
      });
    }
  }, data));
};
function _dispatchEvent(info) {
  dispatchEvent(_objectSpread2({
    putSortable: putSortable,
    cloneEl: cloneEl,
    targetEl: dragEl,
    rootEl: rootEl,
    oldIndex: oldIndex,
    oldDraggableIndex: oldDraggableIndex,
    newIndex: newIndex,
    newDraggableIndex: newDraggableIndex
  }, info));
}
var dragEl,
  parentEl,
  ghostEl,
  rootEl,
  nextEl,
  lastDownEl,
  cloneEl,
  cloneHidden,
  oldIndex,
  newIndex,
  oldDraggableIndex,
  newDraggableIndex,
  activeGroup,
  putSortable,
  awaitingDragStarted = false,
  ignoreNextClick = false,
  sortables = [],
  tapEvt,
  touchEvt,
  lastDx,
  lastDy,
  tapDistanceLeft,
  tapDistanceTop,
  moved,
  lastTarget,
  lastDirection,
  pastFirstInvertThresh = false,
  isCircumstantialInvert = false,
  targetMoveDistance,
  // For positioning ghost absolutely
  ghostRelativeParent,
  ghostRelativeParentInitialScroll = [],
  // (left, top)

  _silent = false,
  savedInputChecked = [];

/** @const */
var documentExists = typeof document !== 'undefined',
  PositionGhostAbsolutely = IOS,
  CSSFloatProperty = Edge || IE11OrLess ? 'cssFloat' : 'float',
  // This will not pass for IE9, because IE9 DnD only works on anchors
  supportDraggable = documentExists && !ChromeForAndroid && !IOS && 'draggable' in document.createElement('div'),
  supportCssPointerEvents = function () {
    if (!documentExists) return;
    // false when <= IE11
    if (IE11OrLess) {
      return false;
    }
    var el = document.createElement('x');
    el.style.cssText = 'pointer-events:auto';
    return el.style.pointerEvents === 'auto';
  }(),
  _detectDirection = function _detectDirection(el, options) {
    var elCSS = css(el),
      elWidth = parseInt(elCSS.width) - parseInt(elCSS.paddingLeft) - parseInt(elCSS.paddingRight) - parseInt(elCSS.borderLeftWidth) - parseInt(elCSS.borderRightWidth),
      child1 = getChild(el, 0, options),
      child2 = getChild(el, 1, options),
      firstChildCSS = child1 && css(child1),
      secondChildCSS = child2 && css(child2),
      firstChildWidth = firstChildCSS && parseInt(firstChildCSS.marginLeft) + parseInt(firstChildCSS.marginRight) + getRect(child1).width,
      secondChildWidth = secondChildCSS && parseInt(secondChildCSS.marginLeft) + parseInt(secondChildCSS.marginRight) + getRect(child2).width;
    if (elCSS.display === 'flex') {
      return elCSS.flexDirection === 'column' || elCSS.flexDirection === 'column-reverse' ? 'vertical' : 'horizontal';
    }
    if (elCSS.display === 'grid') {
      return elCSS.gridTemplateColumns.split(' ').length <= 1 ? 'vertical' : 'horizontal';
    }
    if (child1 && firstChildCSS["float"] && firstChildCSS["float"] !== 'none') {
      var touchingSideChild2 = firstChildCSS["float"] === 'left' ? 'left' : 'right';
      return child2 && (secondChildCSS.clear === 'both' || secondChildCSS.clear === touchingSideChild2) ? 'vertical' : 'horizontal';
    }
    return child1 && (firstChildCSS.display === 'block' || firstChildCSS.display === 'flex' || firstChildCSS.display === 'table' || firstChildCSS.display === 'grid' || firstChildWidth >= elWidth && elCSS[CSSFloatProperty] === 'none' || child2 && elCSS[CSSFloatProperty] === 'none' && firstChildWidth + secondChildWidth > elWidth) ? 'vertical' : 'horizontal';
  },
  _dragElInRowColumn = function _dragElInRowColumn(dragRect, targetRect, vertical) {
    var dragElS1Opp = vertical ? dragRect.left : dragRect.top,
      dragElS2Opp = vertical ? dragRect.right : dragRect.bottom,
      dragElOppLength = vertical ? dragRect.width : dragRect.height,
      targetS1Opp = vertical ? targetRect.left : targetRect.top,
      targetS2Opp = vertical ? targetRect.right : targetRect.bottom,
      targetOppLength = vertical ? targetRect.width : targetRect.height;
    return dragElS1Opp === targetS1Opp || dragElS2Opp === targetS2Opp || dragElS1Opp + dragElOppLength / 2 === targetS1Opp + targetOppLength / 2;
  },
  /**
   * Detects first nearest empty sortable to X and Y position using emptyInsertThreshold.
   * @param  {Number} x      X position
   * @param  {Number} y      Y position
   * @return {HTMLElement}   Element of the first found nearest Sortable
   */
  _detectNearestEmptySortable = function _detectNearestEmptySortable(x, y) {
    var ret;
    sortables.some(function (sortable) {
      var threshold = sortable[expando].options.emptyInsertThreshold;
      if (!threshold || lastChild(sortable)) return;
      var rect = getRect(sortable),
        insideHorizontally = x >= rect.left - threshold && x <= rect.right + threshold,
        insideVertically = y >= rect.top - threshold && y <= rect.bottom + threshold;
      if (insideHorizontally && insideVertically) {
        return ret = sortable;
      }
    });
    return ret;
  },
  _prepareGroup = function _prepareGroup(options) {
    function toFn(value, pull) {
      return function (to, from, dragEl, evt) {
        var sameGroup = to.options.group.name && from.options.group.name && to.options.group.name === from.options.group.name;
        if (value == null && (pull || sameGroup)) {
          // Default pull value
          // Default pull and put value if same group
          return true;
        } else if (value == null || value === false) {
          return false;
        } else if (pull && value === 'clone') {
          return value;
        } else if (typeof value === 'function') {
          return toFn(value(to, from, dragEl, evt), pull)(to, from, dragEl, evt);
        } else {
          var otherGroup = (pull ? to : from).options.group.name;
          return value === true || typeof value === 'string' && value === otherGroup || value.join && value.indexOf(otherGroup) > -1;
        }
      };
    }
    var group = {};
    var originalGroup = options.group;
    if (!originalGroup || _typeof(originalGroup) != 'object') {
      originalGroup = {
        name: originalGroup
      };
    }
    group.name = originalGroup.name;
    group.checkPull = toFn(originalGroup.pull, true);
    group.checkPut = toFn(originalGroup.put);
    group.revertClone = originalGroup.revertClone;
    options.group = group;
  },
  _hideGhostForTarget = function _hideGhostForTarget() {
    if (!supportCssPointerEvents && ghostEl) {
      css(ghostEl, 'display', 'none');
    }
  },
  _unhideGhostForTarget = function _unhideGhostForTarget() {
    if (!supportCssPointerEvents && ghostEl) {
      css(ghostEl, 'display', '');
    }
  };

// #1184 fix - Prevent click event on fallback if dragged but item not changed position
if (documentExists && !ChromeForAndroid) {
  document.addEventListener('click', function (evt) {
    if (ignoreNextClick) {
      evt.preventDefault();
      evt.stopPropagation && evt.stopPropagation();
      evt.stopImmediatePropagation && evt.stopImmediatePropagation();
      ignoreNextClick = false;
      return false;
    }
  }, true);
}
var nearestEmptyInsertDetectEvent = function nearestEmptyInsertDetectEvent(evt) {
  if (dragEl) {
    evt = evt.touches ? evt.touches[0] : evt;
    var nearest = _detectNearestEmptySortable(evt.clientX, evt.clientY);
    if (nearest) {
      // Create imitation event
      var event = {};
      for (var i in evt) {
        if (evt.hasOwnProperty(i)) {
          event[i] = evt[i];
        }
      }
      event.target = event.rootEl = nearest;
      event.preventDefault = void 0;
      event.stopPropagation = void 0;
      nearest[expando]._onDragOver(event);
    }
  }
};
var _checkOutsideTargetEl = function _checkOutsideTargetEl(evt) {
  if (dragEl) {
    dragEl.parentNode[expando]._isOutsideThisEl(evt.target);
  }
};

/**
 * @class  Sortable
 * @param  {HTMLElement}  el
 * @param  {Object}       [options]
 */
function Sortable(el, options) {
  if (!(el && el.nodeType && el.nodeType === 1)) {
    throw "Sortable: `el` must be an HTMLElement, not ".concat({}.toString.call(el));
  }
  this.el = el; // root element
  this.options = options = _extends({}, options);

  // Export instance
  el[expando] = this;
  var defaults = {
    group: null,
    sort: true,
    disabled: false,
    store: null,
    handle: null,
    draggable: /^[uo]l$/i.test(el.nodeName) ? '>li' : '>*',
    swapThreshold: 1,
    // percentage; 0 <= x <= 1
    invertSwap: false,
    // invert always
    invertedSwapThreshold: null,
    // will be set to same as swapThreshold if default
    removeCloneOnHide: true,
    direction: function direction() {
      return _detectDirection(el, this.options);
    },
    ghostClass: 'sortable-ghost',
    chosenClass: 'sortable-chosen',
    dragClass: 'sortable-drag',
    ignore: 'a, img',
    filter: null,
    preventOnFilter: true,
    animation: 0,
    easing: null,
    setData: function setData(dataTransfer, dragEl) {
      dataTransfer.setData('Text', dragEl.textContent);
    },
    dropBubble: false,
    dragoverBubble: false,
    dataIdAttr: 'data-id',
    delay: 0,
    delayOnTouchOnly: false,
    touchStartThreshold: (Number.parseInt ? Number : window).parseInt(window.devicePixelRatio, 10) || 1,
    forceFallback: false,
    fallbackClass: 'sortable-fallback',
    fallbackOnBody: false,
    fallbackTolerance: 0,
    fallbackOffset: {
      x: 0,
      y: 0
    },
    // Disabled on Safari: #1571; Enabled on Safari IOS: #2244
    supportPointer: Sortable.supportPointer !== false && 'PointerEvent' in window && (!Safari || IOS),
    emptyInsertThreshold: 5
  };
  PluginManager.initializePlugins(this, el, defaults);

  // Set default options
  for (var name in defaults) {
    !(name in options) && (options[name] = defaults[name]);
  }
  _prepareGroup(options);

  // Bind all private methods
  for (var fn in this) {
    if (fn.charAt(0) === '_' && typeof this[fn] === 'function') {
      this[fn] = this[fn].bind(this);
    }
  }

  // Setup drag mode
  this.nativeDraggable = options.forceFallback ? false : supportDraggable;
  if (this.nativeDraggable) {
    // Touch start threshold cannot be greater than the native dragstart threshold
    this.options.touchStartThreshold = 1;
  }

  // Bind events
  if (options.supportPointer) {
    on(el, 'pointerdown', this._onTapStart);
  } else {
    on(el, 'mousedown', this._onTapStart);
    on(el, 'touchstart', this._onTapStart);
  }
  if (this.nativeDraggable) {
    on(el, 'dragover', this);
    on(el, 'dragenter', this);
  }
  sortables.push(this.el);

  // Restore sorting
  options.store && options.store.get && this.sort(options.store.get(this) || []);

  // Add animation state manager
  _extends(this, AnimationStateManager());
}
Sortable.prototype = /** @lends Sortable.prototype */{
  constructor: Sortable,
  _isOutsideThisEl: function _isOutsideThisEl(target) {
    if (!this.el.contains(target) && target !== this.el) {
      lastTarget = null;
    }
  },
  _getDirection: function _getDirection(evt, target) {
    return typeof this.options.direction === 'function' ? this.options.direction.call(this, evt, target, dragEl) : this.options.direction;
  },
  _onTapStart: function _onTapStart( /** Event|TouchEvent */evt) {
    if (!evt.cancelable) return;
    var _this = this,
      el = this.el,
      options = this.options,
      preventOnFilter = options.preventOnFilter,
      type = evt.type,
      touch = evt.touches && evt.touches[0] || evt.pointerType && evt.pointerType === 'touch' && evt,
      target = (touch || evt).target,
      originalTarget = evt.target.shadowRoot && (evt.path && evt.path[0] || evt.composedPath && evt.composedPath()[0]) || target,
      filter = options.filter;
    _saveInputCheckedState(el);

    // Don't trigger start event when an element is been dragged, otherwise the evt.oldindex always wrong when set option.group.
    if (dragEl) {
      return;
    }
    if (/mousedown|pointerdown/.test(type) && evt.button !== 0 || options.disabled) {
      return; // only left button and enabled
    }

    // cancel dnd if original target is content editable
    if (originalTarget.isContentEditable) {
      return;
    }

    // Safari ignores further event handling after mousedown
    if (!this.nativeDraggable && Safari && target && target.tagName.toUpperCase() === 'SELECT') {
      return;
    }
    target = closest(target, options.draggable, el, false);
    if (target && target.animated) {
      return;
    }
    if (lastDownEl === target) {
      // Ignoring duplicate `down`
      return;
    }

    // Get the index of the dragged element within its parent
    oldIndex = index(target);
    oldDraggableIndex = index(target, options.draggable);

    // Check filter
    if (typeof filter === 'function') {
      if (filter.call(this, evt, target, this)) {
        _dispatchEvent({
          sortable: _this,
          rootEl: originalTarget,
          name: 'filter',
          targetEl: target,
          toEl: el,
          fromEl: el
        });
        pluginEvent('filter', _this, {
          evt: evt
        });
        preventOnFilter && evt.preventDefault();
        return; // cancel dnd
      }
    } else if (filter) {
      filter = filter.split(',').some(function (criteria) {
        criteria = closest(originalTarget, criteria.trim(), el, false);
        if (criteria) {
          _dispatchEvent({
            sortable: _this,
            rootEl: criteria,
            name: 'filter',
            targetEl: target,
            fromEl: el,
            toEl: el
          });
          pluginEvent('filter', _this, {
            evt: evt
          });
          return true;
        }
      });
      if (filter) {
        preventOnFilter && evt.preventDefault();
        return; // cancel dnd
      }
    }
    if (options.handle && !closest(originalTarget, options.handle, el, false)) {
      return;
    }

    // Prepare `dragstart`
    this._prepareDragStart(evt, touch, target);
  },
  _prepareDragStart: function _prepareDragStart( /** Event */evt, /** Touch */touch, /** HTMLElement */target) {
    var _this = this,
      el = _this.el,
      options = _this.options,
      ownerDocument = el.ownerDocument,
      dragStartFn;
    if (target && !dragEl && target.parentNode === el) {
      var dragRect = getRect(target);
      rootEl = el;
      dragEl = target;
      parentEl = dragEl.parentNode;
      nextEl = dragEl.nextSibling;
      lastDownEl = target;
      activeGroup = options.group;
      Sortable.dragged = dragEl;
      tapEvt = {
        target: dragEl,
        clientX: (touch || evt).clientX,
        clientY: (touch || evt).clientY
      };
      tapDistanceLeft = tapEvt.clientX - dragRect.left;
      tapDistanceTop = tapEvt.clientY - dragRect.top;
      this._lastX = (touch || evt).clientX;
      this._lastY = (touch || evt).clientY;
      dragEl.style['will-change'] = 'all';
      dragStartFn = function dragStartFn() {
        pluginEvent('delayEnded', _this, {
          evt: evt
        });
        if (Sortable.eventCanceled) {
          _this._onDrop();
          return;
        }
        // Delayed drag has been triggered
        // we can re-enable the events: touchmove/mousemove
        _this._disableDelayedDragEvents();
        if (!FireFox && _this.nativeDraggable) {
          dragEl.draggable = true;
        }

        // Bind the events: dragstart/dragend
        _this._triggerDragStart(evt, touch);

        // Drag start event
        _dispatchEvent({
          sortable: _this,
          name: 'choose',
          originalEvent: evt
        });

        // Chosen item
        toggleClass(dragEl, options.chosenClass, true);
      };

      // Disable "draggable"
      options.ignore.split(',').forEach(function (criteria) {
        find(dragEl, criteria.trim(), _disableDraggable);
      });
      on(ownerDocument, 'dragover', nearestEmptyInsertDetectEvent);
      on(ownerDocument, 'mousemove', nearestEmptyInsertDetectEvent);
      on(ownerDocument, 'touchmove', nearestEmptyInsertDetectEvent);
      if (options.supportPointer) {
        on(ownerDocument, 'pointerup', _this._onDrop);
        // Native D&D triggers pointercancel
        !this.nativeDraggable && on(ownerDocument, 'pointercancel', _this._onDrop);
      } else {
        on(ownerDocument, 'mouseup', _this._onDrop);
        on(ownerDocument, 'touchend', _this._onDrop);
        on(ownerDocument, 'touchcancel', _this._onDrop);
      }

      // Make dragEl draggable (must be before delay for FireFox)
      if (FireFox && this.nativeDraggable) {
        this.options.touchStartThreshold = 4;
        dragEl.draggable = true;
      }
      pluginEvent('delayStart', this, {
        evt: evt
      });

      // Delay is impossible for native DnD in Edge or IE
      if (options.delay && (!options.delayOnTouchOnly || touch) && (!this.nativeDraggable || !(Edge || IE11OrLess))) {
        if (Sortable.eventCanceled) {
          this._onDrop();
          return;
        }
        // If the user moves the pointer or let go the click or touch
        // before the delay has been reached:
        // disable the delayed drag
        if (options.supportPointer) {
          on(ownerDocument, 'pointerup', _this._disableDelayedDrag);
          on(ownerDocument, 'pointercancel', _this._disableDelayedDrag);
        } else {
          on(ownerDocument, 'mouseup', _this._disableDelayedDrag);
          on(ownerDocument, 'touchend', _this._disableDelayedDrag);
          on(ownerDocument, 'touchcancel', _this._disableDelayedDrag);
        }
        on(ownerDocument, 'mousemove', _this._delayedDragTouchMoveHandler);
        on(ownerDocument, 'touchmove', _this._delayedDragTouchMoveHandler);
        options.supportPointer && on(ownerDocument, 'pointermove', _this._delayedDragTouchMoveHandler);
        _this._dragStartTimer = setTimeout(dragStartFn, options.delay);
      } else {
        dragStartFn();
      }
    }
  },
  _delayedDragTouchMoveHandler: function _delayedDragTouchMoveHandler( /** TouchEvent|PointerEvent **/e) {
    var touch = e.touches ? e.touches[0] : e;
    if (Math.max(Math.abs(touch.clientX - this._lastX), Math.abs(touch.clientY - this._lastY)) >= Math.floor(this.options.touchStartThreshold / (this.nativeDraggable && window.devicePixelRatio || 1))) {
      this._disableDelayedDrag();
    }
  },
  _disableDelayedDrag: function _disableDelayedDrag() {
    dragEl && _disableDraggable(dragEl);
    clearTimeout(this._dragStartTimer);
    this._disableDelayedDragEvents();
  },
  _disableDelayedDragEvents: function _disableDelayedDragEvents() {
    var ownerDocument = this.el.ownerDocument;
    off(ownerDocument, 'mouseup', this._disableDelayedDrag);
    off(ownerDocument, 'touchend', this._disableDelayedDrag);
    off(ownerDocument, 'touchcancel', this._disableDelayedDrag);
    off(ownerDocument, 'pointerup', this._disableDelayedDrag);
    off(ownerDocument, 'pointercancel', this._disableDelayedDrag);
    off(ownerDocument, 'mousemove', this._delayedDragTouchMoveHandler);
    off(ownerDocument, 'touchmove', this._delayedDragTouchMoveHandler);
    off(ownerDocument, 'pointermove', this._delayedDragTouchMoveHandler);
  },
  _triggerDragStart: function _triggerDragStart( /** Event */evt, /** Touch */touch) {
    touch = touch || evt.pointerType == 'touch' && evt;
    if (!this.nativeDraggable || touch) {
      if (this.options.supportPointer) {
        on(document, 'pointermove', this._onTouchMove);
      } else if (touch) {
        on(document, 'touchmove', this._onTouchMove);
      } else {
        on(document, 'mousemove', this._onTouchMove);
      }
    } else {
      on(dragEl, 'dragend', this);
      on(rootEl, 'dragstart', this._onDragStart);
    }
    try {
      if (document.selection) {
        _nextTick(function () {
          document.selection.empty();
        });
      } else {
        window.getSelection().removeAllRanges();
      }
    } catch (err) {}
  },
  _dragStarted: function _dragStarted(fallback, evt) {
    awaitingDragStarted = false;
    if (rootEl && dragEl) {
      pluginEvent('dragStarted', this, {
        evt: evt
      });
      if (this.nativeDraggable) {
        on(document, 'dragover', _checkOutsideTargetEl);
      }
      var options = this.options;

      // Apply effect
      !fallback && toggleClass(dragEl, options.dragClass, false);
      toggleClass(dragEl, options.ghostClass, true);
      Sortable.active = this;
      fallback && this._appendGhost();

      // Drag start event
      _dispatchEvent({
        sortable: this,
        name: 'start',
        originalEvent: evt
      });
    } else {
      this._nulling();
    }
  },
  _emulateDragOver: function _emulateDragOver() {
    if (touchEvt) {
      this._lastX = touchEvt.clientX;
      this._lastY = touchEvt.clientY;
      _hideGhostForTarget();
      var target = document.elementFromPoint(touchEvt.clientX, touchEvt.clientY);
      var parent = target;
      while (target && target.shadowRoot) {
        target = target.shadowRoot.elementFromPoint(touchEvt.clientX, touchEvt.clientY);
        if (target === parent) break;
        parent = target;
      }
      dragEl.parentNode[expando]._isOutsideThisEl(target);
      if (parent) {
        do {
          if (parent[expando]) {
            var inserted = void 0;
            inserted = parent[expando]._onDragOver({
              clientX: touchEvt.clientX,
              clientY: touchEvt.clientY,
              target: target,
              rootEl: parent
            });
            if (inserted && !this.options.dragoverBubble) {
              break;
            }
          }
          target = parent; // store last element
        }
        /* jshint boss:true */ while (parent = getParentOrHost(parent));
      }
      _unhideGhostForTarget();
    }
  },
  _onTouchMove: function _onTouchMove( /**TouchEvent*/evt) {
    if (tapEvt) {
      var options = this.options,
        fallbackTolerance = options.fallbackTolerance,
        fallbackOffset = options.fallbackOffset,
        touch = evt.touches ? evt.touches[0] : evt,
        ghostMatrix = ghostEl && matrix(ghostEl, true),
        scaleX = ghostEl && ghostMatrix && ghostMatrix.a,
        scaleY = ghostEl && ghostMatrix && ghostMatrix.d,
        relativeScrollOffset = PositionGhostAbsolutely && ghostRelativeParent && getRelativeScrollOffset(ghostRelativeParent),
        dx = (touch.clientX - tapEvt.clientX + fallbackOffset.x) / (scaleX || 1) + (relativeScrollOffset ? relativeScrollOffset[0] - ghostRelativeParentInitialScroll[0] : 0) / (scaleX || 1),
        dy = (touch.clientY - tapEvt.clientY + fallbackOffset.y) / (scaleY || 1) + (relativeScrollOffset ? relativeScrollOffset[1] - ghostRelativeParentInitialScroll[1] : 0) / (scaleY || 1);

      // only set the status to dragging, when we are actually dragging
      if (!Sortable.active && !awaitingDragStarted) {
        if (fallbackTolerance && Math.max(Math.abs(touch.clientX - this._lastX), Math.abs(touch.clientY - this._lastY)) < fallbackTolerance) {
          return;
        }
        this._onDragStart(evt, true);
      }
      if (ghostEl) {
        if (ghostMatrix) {
          ghostMatrix.e += dx - (lastDx || 0);
          ghostMatrix.f += dy - (lastDy || 0);
        } else {
          ghostMatrix = {
            a: 1,
            b: 0,
            c: 0,
            d: 1,
            e: dx,
            f: dy
          };
        }
        var cssMatrix = "matrix(".concat(ghostMatrix.a, ",").concat(ghostMatrix.b, ",").concat(ghostMatrix.c, ",").concat(ghostMatrix.d, ",").concat(ghostMatrix.e, ",").concat(ghostMatrix.f, ")");
        css(ghostEl, 'webkitTransform', cssMatrix);
        css(ghostEl, 'mozTransform', cssMatrix);
        css(ghostEl, 'msTransform', cssMatrix);
        css(ghostEl, 'transform', cssMatrix);
        lastDx = dx;
        lastDy = dy;
        touchEvt = touch;
      }
      evt.cancelable && evt.preventDefault();
    }
  },
  _appendGhost: function _appendGhost() {
    // Bug if using scale(): https://stackoverflow.com/questions/2637058
    // Not being adjusted for
    if (!ghostEl) {
      var container = this.options.fallbackOnBody ? document.body : rootEl,
        rect = getRect(dragEl, true, PositionGhostAbsolutely, true, container),
        options = this.options;

      // Position absolutely
      if (PositionGhostAbsolutely) {
        // Get relatively positioned parent
        ghostRelativeParent = container;
        while (css(ghostRelativeParent, 'position') === 'static' && css(ghostRelativeParent, 'transform') === 'none' && ghostRelativeParent !== document) {
          ghostRelativeParent = ghostRelativeParent.parentNode;
        }
        if (ghostRelativeParent !== document.body && ghostRelativeParent !== document.documentElement) {
          if (ghostRelativeParent === document) ghostRelativeParent = getWindowScrollingElement();
          rect.top += ghostRelativeParent.scrollTop;
          rect.left += ghostRelativeParent.scrollLeft;
        } else {
          ghostRelativeParent = getWindowScrollingElement();
        }
        ghostRelativeParentInitialScroll = getRelativeScrollOffset(ghostRelativeParent);
      }
      ghostEl = dragEl.cloneNode(true);
      toggleClass(ghostEl, options.ghostClass, false);
      toggleClass(ghostEl, options.fallbackClass, true);
      toggleClass(ghostEl, options.dragClass, true);
      css(ghostEl, 'transition', '');
      css(ghostEl, 'transform', '');
      css(ghostEl, 'box-sizing', 'border-box');
      css(ghostEl, 'margin', 0);
      css(ghostEl, 'top', rect.top);
      css(ghostEl, 'left', rect.left);
      css(ghostEl, 'width', rect.width);
      css(ghostEl, 'height', rect.height);
      css(ghostEl, 'opacity', '0.8');
      css(ghostEl, 'position', PositionGhostAbsolutely ? 'absolute' : 'fixed');
      css(ghostEl, 'zIndex', '100000');
      css(ghostEl, 'pointerEvents', 'none');
      Sortable.ghost = ghostEl;
      container.appendChild(ghostEl);

      // Set transform-origin
      css(ghostEl, 'transform-origin', tapDistanceLeft / parseInt(ghostEl.style.width) * 100 + '% ' + tapDistanceTop / parseInt(ghostEl.style.height) * 100 + '%');
    }
  },
  _onDragStart: function _onDragStart( /**Event*/evt, /**boolean*/fallback) {
    var _this = this;
    var dataTransfer = evt.dataTransfer;
    var options = _this.options;
    pluginEvent('dragStart', this, {
      evt: evt
    });
    if (Sortable.eventCanceled) {
      this._onDrop();
      return;
    }
    pluginEvent('setupClone', this);
    if (!Sortable.eventCanceled) {
      cloneEl = clone(dragEl);
      cloneEl.removeAttribute("id");
      cloneEl.draggable = false;
      cloneEl.style['will-change'] = '';
      this._hideClone();
      toggleClass(cloneEl, this.options.chosenClass, false);
      Sortable.clone = cloneEl;
    }

    // #1143: IFrame support workaround
    _this.cloneId = _nextTick(function () {
      pluginEvent('clone', _this);
      if (Sortable.eventCanceled) return;
      if (!_this.options.removeCloneOnHide) {
        rootEl.insertBefore(cloneEl, dragEl);
      }
      _this._hideClone();
      _dispatchEvent({
        sortable: _this,
        name: 'clone'
      });
    });
    !fallback && toggleClass(dragEl, options.dragClass, true);

    // Set proper drop events
    if (fallback) {
      ignoreNextClick = true;
      _this._loopId = setInterval(_this._emulateDragOver, 50);
    } else {
      // Undo what was set in _prepareDragStart before drag started
      off(document, 'mouseup', _this._onDrop);
      off(document, 'touchend', _this._onDrop);
      off(document, 'touchcancel', _this._onDrop);
      if (dataTransfer) {
        dataTransfer.effectAllowed = 'move';
        options.setData && options.setData.call(_this, dataTransfer, dragEl);
      }
      on(document, 'drop', _this);

      // #1276 fix:
      css(dragEl, 'transform', 'translateZ(0)');
    }
    awaitingDragStarted = true;
    _this._dragStartId = _nextTick(_this._dragStarted.bind(_this, fallback, evt));
    on(document, 'selectstart', _this);
    moved = true;
    window.getSelection().removeAllRanges();
    if (Safari) {
      css(document.body, 'user-select', 'none');
    }
  },
  // Returns true - if no further action is needed (either inserted or another condition)
  _onDragOver: function _onDragOver( /**Event*/evt) {
    var el = this.el,
      target = evt.target,
      dragRect,
      targetRect,
      revert,
      options = this.options,
      group = options.group,
      activeSortable = Sortable.active,
      isOwner = activeGroup === group,
      canSort = options.sort,
      fromSortable = putSortable || activeSortable,
      vertical,
      _this = this,
      completedFired = false;
    if (_silent) return;
    function dragOverEvent(name, extra) {
      pluginEvent(name, _this, _objectSpread2({
        evt: evt,
        isOwner: isOwner,
        axis: vertical ? 'vertical' : 'horizontal',
        revert: revert,
        dragRect: dragRect,
        targetRect: targetRect,
        canSort: canSort,
        fromSortable: fromSortable,
        target: target,
        completed: completed,
        onMove: function onMove(target, after) {
          return _onMove(rootEl, el, dragEl, dragRect, target, getRect(target), evt, after);
        },
        changed: changed
      }, extra));
    }

    // Capture animation state
    function capture() {
      dragOverEvent('dragOverAnimationCapture');
      _this.captureAnimationState();
      if (_this !== fromSortable) {
        fromSortable.captureAnimationState();
      }
    }

    // Return invocation when dragEl is inserted (or completed)
    function completed(insertion) {
      dragOverEvent('dragOverCompleted', {
        insertion: insertion
      });
      if (insertion) {
        // Clones must be hidden before folding animation to capture dragRectAbsolute properly
        if (isOwner) {
          activeSortable._hideClone();
        } else {
          activeSortable._showClone(_this);
        }
        if (_this !== fromSortable) {
          // Set ghost class to new sortable's ghost class
          toggleClass(dragEl, putSortable ? putSortable.options.ghostClass : activeSortable.options.ghostClass, false);
          toggleClass(dragEl, options.ghostClass, true);
        }
        if (putSortable !== _this && _this !== Sortable.active) {
          putSortable = _this;
        } else if (_this === Sortable.active && putSortable) {
          putSortable = null;
        }

        // Animation
        if (fromSortable === _this) {
          _this._ignoreWhileAnimating = target;
        }
        _this.animateAll(function () {
          dragOverEvent('dragOverAnimationComplete');
          _this._ignoreWhileAnimating = null;
        });
        if (_this !== fromSortable) {
          fromSortable.animateAll();
          fromSortable._ignoreWhileAnimating = null;
        }
      }

      // Null lastTarget if it is not inside a previously swapped element
      if (target === dragEl && !dragEl.animated || target === el && !target.animated) {
        lastTarget = null;
      }

      // no bubbling and not fallback
      if (!options.dragoverBubble && !evt.rootEl && target !== document) {
        dragEl.parentNode[expando]._isOutsideThisEl(evt.target);

        // Do not detect for empty insert if already inserted
        !insertion && nearestEmptyInsertDetectEvent(evt);
      }
      !options.dragoverBubble && evt.stopPropagation && evt.stopPropagation();
      return completedFired = true;
    }

    // Call when dragEl has been inserted
    function changed() {
      newIndex = index(dragEl);
      newDraggableIndex = index(dragEl, options.draggable);
      _dispatchEvent({
        sortable: _this,
        name: 'change',
        toEl: el,
        newIndex: newIndex,
        newDraggableIndex: newDraggableIndex,
        originalEvent: evt
      });
    }
    if (evt.preventDefault !== void 0) {
      evt.cancelable && evt.preventDefault();
    }
    target = closest(target, options.draggable, el, true);
    dragOverEvent('dragOver');
    if (Sortable.eventCanceled) return completedFired;
    if (dragEl.contains(evt.target) || target.animated && target.animatingX && target.animatingY || _this._ignoreWhileAnimating === target) {
      return completed(false);
    }
    ignoreNextClick = false;
    if (activeSortable && !options.disabled && (isOwner ? canSort || (revert = parentEl !== rootEl) // Reverting item into the original list
    : putSortable === this || (this.lastPutMode = activeGroup.checkPull(this, activeSortable, dragEl, evt)) && group.checkPut(this, activeSortable, dragEl, evt))) {
      vertical = this._getDirection(evt, target) === 'vertical';
      dragRect = getRect(dragEl);
      dragOverEvent('dragOverValid');
      if (Sortable.eventCanceled) return completedFired;
      if (revert) {
        parentEl = rootEl; // actualization
        capture();
        this._hideClone();
        dragOverEvent('revert');
        if (!Sortable.eventCanceled) {
          if (nextEl) {
            rootEl.insertBefore(dragEl, nextEl);
          } else {
            rootEl.appendChild(dragEl);
          }
        }
        return completed(true);
      }
      var elLastChild = lastChild(el, options.draggable);
      if (!elLastChild || _ghostIsLast(evt, vertical, this) && !elLastChild.animated) {
        // Insert to end of list

        // If already at end of list: Do not insert
        if (elLastChild === dragEl) {
          return completed(false);
        }

        // if there is a last element, it is the target
        if (elLastChild && el === evt.target) {
          target = elLastChild;
        }
        if (target) {
          targetRect = getRect(target);
        }
        if (_onMove(rootEl, el, dragEl, dragRect, target, targetRect, evt, !!target) !== false) {
          capture();
          if (elLastChild && elLastChild.nextSibling) {
            // the last draggable element is not the last node
            el.insertBefore(dragEl, elLastChild.nextSibling);
          } else {
            el.appendChild(dragEl);
          }
          parentEl = el; // actualization

          changed();
          return completed(true);
        }
      } else if (elLastChild && _ghostIsFirst(evt, vertical, this)) {
        // Insert to start of list
        var firstChild = getChild(el, 0, options, true);
        if (firstChild === dragEl) {
          return completed(false);
        }
        target = firstChild;
        targetRect = getRect(target);
        if (_onMove(rootEl, el, dragEl, dragRect, target, targetRect, evt, false) !== false) {
          capture();
          el.insertBefore(dragEl, firstChild);
          parentEl = el; // actualization

          changed();
          return completed(true);
        }
      } else if (target.parentNode === el) {
        targetRect = getRect(target);
        var direction = 0,
          targetBeforeFirstSwap,
          differentLevel = dragEl.parentNode !== el,
          differentRowCol = !_dragElInRowColumn(dragEl.animated && dragEl.toRect || dragRect, target.animated && target.toRect || targetRect, vertical),
          side1 = vertical ? 'top' : 'left',
          scrolledPastTop = isScrolledPast(target, 'top', 'top') || isScrolledPast(dragEl, 'top', 'top'),
          scrollBefore = scrolledPastTop ? scrolledPastTop.scrollTop : void 0;
        if (lastTarget !== target) {
          targetBeforeFirstSwap = targetRect[side1];
          pastFirstInvertThresh = false;
          isCircumstantialInvert = !differentRowCol && options.invertSwap || differentLevel;
        }
        direction = _getSwapDirection(evt, target, targetRect, vertical, differentRowCol ? 1 : options.swapThreshold, options.invertedSwapThreshold == null ? options.swapThreshold : options.invertedSwapThreshold, isCircumstantialInvert, lastTarget === target);
        var sibling;
        if (direction !== 0) {
          // Check if target is beside dragEl in respective direction (ignoring hidden elements)
          var dragIndex = index(dragEl);
          do {
            dragIndex -= direction;
            sibling = parentEl.children[dragIndex];
          } while (sibling && (css(sibling, 'display') === 'none' || sibling === ghostEl));
        }
        // If dragEl is already beside target: Do not insert
        if (direction === 0 || sibling === target) {
          return completed(false);
        }
        lastTarget = target;
        lastDirection = direction;
        var nextSibling = target.nextElementSibling,
          after = false;
        after = direction === 1;
        var moveVector = _onMove(rootEl, el, dragEl, dragRect, target, targetRect, evt, after);
        if (moveVector !== false) {
          if (moveVector === 1 || moveVector === -1) {
            after = moveVector === 1;
          }
          _silent = true;
          setTimeout(_unsilent, 30);
          capture();
          if (after && !nextSibling) {
            el.appendChild(dragEl);
          } else {
            target.parentNode.insertBefore(dragEl, after ? nextSibling : target);
          }

          // Undo chrome's scroll adjustment (has no effect on other browsers)
          if (scrolledPastTop) {
            scrollBy(scrolledPastTop, 0, scrollBefore - scrolledPastTop.scrollTop);
          }
          parentEl = dragEl.parentNode; // actualization

          // must be done before animation
          if (targetBeforeFirstSwap !== undefined && !isCircumstantialInvert) {
            targetMoveDistance = Math.abs(targetBeforeFirstSwap - getRect(target)[side1]);
          }
          changed();
          return completed(true);
        }
      }
      if (el.contains(dragEl)) {
        return completed(false);
      }
    }
    return false;
  },
  _ignoreWhileAnimating: null,
  _offMoveEvents: function _offMoveEvents() {
    off(document, 'mousemove', this._onTouchMove);
    off(document, 'touchmove', this._onTouchMove);
    off(document, 'pointermove', this._onTouchMove);
    off(document, 'dragover', nearestEmptyInsertDetectEvent);
    off(document, 'mousemove', nearestEmptyInsertDetectEvent);
    off(document, 'touchmove', nearestEmptyInsertDetectEvent);
  },
  _offUpEvents: function _offUpEvents() {
    var ownerDocument = this.el.ownerDocument;
    off(ownerDocument, 'mouseup', this._onDrop);
    off(ownerDocument, 'touchend', this._onDrop);
    off(ownerDocument, 'pointerup', this._onDrop);
    off(ownerDocument, 'pointercancel', this._onDrop);
    off(ownerDocument, 'touchcancel', this._onDrop);
    off(document, 'selectstart', this);
  },
  _onDrop: function _onDrop( /**Event*/evt) {
    var el = this.el,
      options = this.options;

    // Get the index of the dragged element within its parent
    newIndex = index(dragEl);
    newDraggableIndex = index(dragEl, options.draggable);
    pluginEvent('drop', this, {
      evt: evt
    });
    parentEl = dragEl && dragEl.parentNode;

    // Get again after plugin event
    newIndex = index(dragEl);
    newDraggableIndex = index(dragEl, options.draggable);
    if (Sortable.eventCanceled) {
      this._nulling();
      return;
    }
    awaitingDragStarted = false;
    isCircumstantialInvert = false;
    pastFirstInvertThresh = false;
    clearInterval(this._loopId);
    clearTimeout(this._dragStartTimer);
    _cancelNextTick(this.cloneId);
    _cancelNextTick(this._dragStartId);

    // Unbind events
    if (this.nativeDraggable) {
      off(document, 'drop', this);
      off(el, 'dragstart', this._onDragStart);
    }
    this._offMoveEvents();
    this._offUpEvents();
    if (Safari) {
      css(document.body, 'user-select', '');
    }
    css(dragEl, 'transform', '');
    if (evt) {
      if (moved) {
        evt.cancelable && evt.preventDefault();
        !options.dropBubble && evt.stopPropagation();
      }
      ghostEl && ghostEl.parentNode && ghostEl.parentNode.removeChild(ghostEl);
      if (rootEl === parentEl || putSortable && putSortable.lastPutMode !== 'clone') {
        // Remove clone(s)
        cloneEl && cloneEl.parentNode && cloneEl.parentNode.removeChild(cloneEl);
      }
      if (dragEl) {
        if (this.nativeDraggable) {
          off(dragEl, 'dragend', this);
        }
        _disableDraggable(dragEl);
        dragEl.style['will-change'] = '';

        // Remove classes
        // ghostClass is added in dragStarted
        if (moved && !awaitingDragStarted) {
          toggleClass(dragEl, putSortable ? putSortable.options.ghostClass : this.options.ghostClass, false);
        }
        toggleClass(dragEl, this.options.chosenClass, false);

        // Drag stop event
        _dispatchEvent({
          sortable: this,
          name: 'unchoose',
          toEl: parentEl,
          newIndex: null,
          newDraggableIndex: null,
          originalEvent: evt
        });
        if (rootEl !== parentEl) {
          if (newIndex >= 0) {
            // Add event
            _dispatchEvent({
              rootEl: parentEl,
              name: 'add',
              toEl: parentEl,
              fromEl: rootEl,
              originalEvent: evt
            });

            // Remove event
            _dispatchEvent({
              sortable: this,
              name: 'remove',
              toEl: parentEl,
              originalEvent: evt
            });

            // drag from one list and drop into another
            _dispatchEvent({
              rootEl: parentEl,
              name: 'sort',
              toEl: parentEl,
              fromEl: rootEl,
              originalEvent: evt
            });
            _dispatchEvent({
              sortable: this,
              name: 'sort',
              toEl: parentEl,
              originalEvent: evt
            });
          }
          putSortable && putSortable.save();
        } else {
          if (newIndex !== oldIndex) {
            if (newIndex >= 0) {
              // drag & drop within the same list
              _dispatchEvent({
                sortable: this,
                name: 'update',
                toEl: parentEl,
                originalEvent: evt
              });
              _dispatchEvent({
                sortable: this,
                name: 'sort',
                toEl: parentEl,
                originalEvent: evt
              });
            }
          }
        }
        if (Sortable.active) {
          /* jshint eqnull:true */
          if (newIndex == null || newIndex === -1) {
            newIndex = oldIndex;
            newDraggableIndex = oldDraggableIndex;
          }
          _dispatchEvent({
            sortable: this,
            name: 'end',
            toEl: parentEl,
            originalEvent: evt
          });

          // Save sorting
          this.save();
        }
      }
    }
    this._nulling();
  },
  _nulling: function _nulling() {
    pluginEvent('nulling', this);
    rootEl = dragEl = parentEl = ghostEl = nextEl = cloneEl = lastDownEl = cloneHidden = tapEvt = touchEvt = moved = newIndex = newDraggableIndex = oldIndex = oldDraggableIndex = lastTarget = lastDirection = putSortable = activeGroup = Sortable.dragged = Sortable.ghost = Sortable.clone = Sortable.active = null;
    savedInputChecked.forEach(function (el) {
      el.checked = true;
    });
    savedInputChecked.length = lastDx = lastDy = 0;
  },
  handleEvent: function handleEvent( /**Event*/evt) {
    switch (evt.type) {
      case 'drop':
      case 'dragend':
        this._onDrop(evt);
        break;
      case 'dragenter':
      case 'dragover':
        if (dragEl) {
          this._onDragOver(evt);
          _globalDragOver(evt);
        }
        break;
      case 'selectstart':
        evt.preventDefault();
        break;
    }
  },
  /**
   * Serializes the item into an array of string.
   * @returns {String[]}
   */
  toArray: function toArray() {
    var order = [],
      el,
      children = this.el.children,
      i = 0,
      n = children.length,
      options = this.options;
    for (; i < n; i++) {
      el = children[i];
      if (closest(el, options.draggable, this.el, false)) {
        order.push(el.getAttribute(options.dataIdAttr) || _generateId(el));
      }
    }
    return order;
  },
  /**
   * Sorts the elements according to the array.
   * @param  {String[]}  order  order of the items
   */
  sort: function sort(order, useAnimation) {
    var items = {},
      rootEl = this.el;
    this.toArray().forEach(function (id, i) {
      var el = rootEl.children[i];
      if (closest(el, this.options.draggable, rootEl, false)) {
        items[id] = el;
      }
    }, this);
    useAnimation && this.captureAnimationState();
    order.forEach(function (id) {
      if (items[id]) {
        rootEl.removeChild(items[id]);
        rootEl.appendChild(items[id]);
      }
    });
    useAnimation && this.animateAll();
  },
  /**
   * Save the current sorting
   */
  save: function save() {
    var store = this.options.store;
    store && store.set && store.set(this);
  },
  /**
   * For each element in the set, get the first element that matches the selector by testing the element itself and traversing up through its ancestors in the DOM tree.
   * @param   {HTMLElement}  el
   * @param   {String}       [selector]  default: `options.draggable`
   * @returns {HTMLElement|null}
   */
  closest: function closest$1(el, selector) {
    return closest(el, selector || this.options.draggable, this.el, false);
  },
  /**
   * Set/get option
   * @param   {string} name
   * @param   {*}      [value]
   * @returns {*}
   */
  option: function option(name, value) {
    var options = this.options;
    if (value === void 0) {
      return options[name];
    } else {
      var modifiedValue = PluginManager.modifyOption(this, name, value);
      if (typeof modifiedValue !== 'undefined') {
        options[name] = modifiedValue;
      } else {
        options[name] = value;
      }
      if (name === 'group') {
        _prepareGroup(options);
      }
    }
  },
  /**
   * Destroy
   */
  destroy: function destroy() {
    pluginEvent('destroy', this);
    var el = this.el;
    el[expando] = null;
    off(el, 'mousedown', this._onTapStart);
    off(el, 'touchstart', this._onTapStart);
    off(el, 'pointerdown', this._onTapStart);
    if (this.nativeDraggable) {
      off(el, 'dragover', this);
      off(el, 'dragenter', this);
    }
    // Remove draggable attributes
    Array.prototype.forEach.call(el.querySelectorAll('[draggable]'), function (el) {
      el.removeAttribute('draggable');
    });
    this._onDrop();
    this._disableDelayedDragEvents();
    sortables.splice(sortables.indexOf(this.el), 1);
    this.el = el = null;
  },
  _hideClone: function _hideClone() {
    if (!cloneHidden) {
      pluginEvent('hideClone', this);
      if (Sortable.eventCanceled) return;
      css(cloneEl, 'display', 'none');
      if (this.options.removeCloneOnHide && cloneEl.parentNode) {
        cloneEl.parentNode.removeChild(cloneEl);
      }
      cloneHidden = true;
    }
  },
  _showClone: function _showClone(putSortable) {
    if (putSortable.lastPutMode !== 'clone') {
      this._hideClone();
      return;
    }
    if (cloneHidden) {
      pluginEvent('showClone', this);
      if (Sortable.eventCanceled) return;

      // show clone at dragEl or original position
      if (dragEl.parentNode == rootEl && !this.options.group.revertClone) {
        rootEl.insertBefore(cloneEl, dragEl);
      } else if (nextEl) {
        rootEl.insertBefore(cloneEl, nextEl);
      } else {
        rootEl.appendChild(cloneEl);
      }
      if (this.options.group.revertClone) {
        this.animate(dragEl, cloneEl);
      }
      css(cloneEl, 'display', '');
      cloneHidden = false;
    }
  }
};
function _globalDragOver( /**Event*/evt) {
  if (evt.dataTransfer) {
    evt.dataTransfer.dropEffect = 'move';
  }
  evt.cancelable && evt.preventDefault();
}
function _onMove(fromEl, toEl, dragEl, dragRect, targetEl, targetRect, originalEvent, willInsertAfter) {
  var evt,
    sortable = fromEl[expando],
    onMoveFn = sortable.options.onMove,
    retVal;
  // Support for new CustomEvent feature
  if (window.CustomEvent && !IE11OrLess && !Edge) {
    evt = new CustomEvent('move', {
      bubbles: true,
      cancelable: true
    });
  } else {
    evt = document.createEvent('Event');
    evt.initEvent('move', true, true);
  }
  evt.to = toEl;
  evt.from = fromEl;
  evt.dragged = dragEl;
  evt.draggedRect = dragRect;
  evt.related = targetEl || toEl;
  evt.relatedRect = targetRect || getRect(toEl);
  evt.willInsertAfter = willInsertAfter;
  evt.originalEvent = originalEvent;
  fromEl.dispatchEvent(evt);
  if (onMoveFn) {
    retVal = onMoveFn.call(sortable, evt, originalEvent);
  }
  return retVal;
}
function _disableDraggable(el) {
  el.draggable = false;
}
function _unsilent() {
  _silent = false;
}
function _ghostIsFirst(evt, vertical, sortable) {
  var firstElRect = getRect(getChild(sortable.el, 0, sortable.options, true));
  var childContainingRect = getChildContainingRectFromElement(sortable.el, sortable.options, ghostEl);
  var spacer = 10;
  return vertical ? evt.clientX < childContainingRect.left - spacer || evt.clientY < firstElRect.top && evt.clientX < firstElRect.right : evt.clientY < childContainingRect.top - spacer || evt.clientY < firstElRect.bottom && evt.clientX < firstElRect.left;
}
function _ghostIsLast(evt, vertical, sortable) {
  var lastElRect = getRect(lastChild(sortable.el, sortable.options.draggable));
  var childContainingRect = getChildContainingRectFromElement(sortable.el, sortable.options, ghostEl);
  var spacer = 10;
  return vertical ? evt.clientX > childContainingRect.right + spacer || evt.clientY > lastElRect.bottom && evt.clientX > lastElRect.left : evt.clientY > childContainingRect.bottom + spacer || evt.clientX > lastElRect.right && evt.clientY > lastElRect.top;
}
function _getSwapDirection(evt, target, targetRect, vertical, swapThreshold, invertedSwapThreshold, invertSwap, isLastTarget) {
  var mouseOnAxis = vertical ? evt.clientY : evt.clientX,
    targetLength = vertical ? targetRect.height : targetRect.width,
    targetS1 = vertical ? targetRect.top : targetRect.left,
    targetS2 = vertical ? targetRect.bottom : targetRect.right,
    invert = false;
  if (!invertSwap) {
    // Never invert or create dragEl shadow when target movemenet causes mouse to move past the end of regular swapThreshold
    if (isLastTarget && targetMoveDistance < targetLength * swapThreshold) {
      // multiplied only by swapThreshold because mouse will already be inside target by (1 - threshold) * targetLength / 2
      // check if past first invert threshold on side opposite of lastDirection
      if (!pastFirstInvertThresh && (lastDirection === 1 ? mouseOnAxis > targetS1 + targetLength * invertedSwapThreshold / 2 : mouseOnAxis < targetS2 - targetLength * invertedSwapThreshold / 2)) {
        // past first invert threshold, do not restrict inverted threshold to dragEl shadow
        pastFirstInvertThresh = true;
      }
      if (!pastFirstInvertThresh) {
        // dragEl shadow (target move distance shadow)
        if (lastDirection === 1 ? mouseOnAxis < targetS1 + targetMoveDistance // over dragEl shadow
        : mouseOnAxis > targetS2 - targetMoveDistance) {
          return -lastDirection;
        }
      } else {
        invert = true;
      }
    } else {
      // Regular
      if (mouseOnAxis > targetS1 + targetLength * (1 - swapThreshold) / 2 && mouseOnAxis < targetS2 - targetLength * (1 - swapThreshold) / 2) {
        return _getInsertDirection(target);
      }
    }
  }
  invert = invert || invertSwap;
  if (invert) {
    // Invert of regular
    if (mouseOnAxis < targetS1 + targetLength * invertedSwapThreshold / 2 || mouseOnAxis > targetS2 - targetLength * invertedSwapThreshold / 2) {
      return mouseOnAxis > targetS1 + targetLength / 2 ? 1 : -1;
    }
  }
  return 0;
}

/**
 * Gets the direction dragEl must be swapped relative to target in order to make it
 * seem that dragEl has been "inserted" into that element's position
 * @param  {HTMLElement} target       The target whose position dragEl is being inserted at
 * @return {Number}                   Direction dragEl must be swapped
 */
function _getInsertDirection(target) {
  if (index(dragEl) < index(target)) {
    return 1;
  } else {
    return -1;
  }
}

/**
 * Generate id
 * @param   {HTMLElement} el
 * @returns {String}
 * @private
 */
function _generateId(el) {
  var str = el.tagName + el.className + el.src + el.href + el.textContent,
    i = str.length,
    sum = 0;
  while (i--) {
    sum += str.charCodeAt(i);
  }
  return sum.toString(36);
}
function _saveInputCheckedState(root) {
  savedInputChecked.length = 0;
  var inputs = root.getElementsByTagName('input');
  var idx = inputs.length;
  while (idx--) {
    var el = inputs[idx];
    el.checked && savedInputChecked.push(el);
  }
}
function _nextTick(fn) {
  return setTimeout(fn, 0);
}
function _cancelNextTick(id) {
  return clearTimeout(id);
}

// Fixed #973:
if (documentExists) {
  on(document, 'touchmove', function (evt) {
    if ((Sortable.active || awaitingDragStarted) && evt.cancelable) {
      evt.preventDefault();
    }
  });
}

// Export utils
Sortable.utils = {
  on: on,
  off: off,
  css: css,
  find: find,
  is: function is(el, selector) {
    return !!closest(el, selector, el, false);
  },
  extend: extend,
  throttle: throttle,
  closest: closest,
  toggleClass: toggleClass,
  clone: clone,
  index: index,
  nextTick: _nextTick,
  cancelNextTick: _cancelNextTick,
  detectDirection: _detectDirection,
  getChild: getChild,
  expando: expando
};

/**
 * Get the Sortable instance of an element
 * @param  {HTMLElement} element The element
 * @return {Sortable|undefined}         The instance of Sortable
 */
Sortable.get = function (element) {
  return element[expando];
};

/**
 * Mount a plugin to Sortable
 * @param  {...SortablePlugin|SortablePlugin[]} plugins       Plugins being mounted
 */
Sortable.mount = function () {
  for (var _len = arguments.length, plugins = new Array(_len), _key = 0; _key < _len; _key++) {
    plugins[_key] = arguments[_key];
  }
  if (plugins[0].constructor === Array) plugins = plugins[0];
  plugins.forEach(function (plugin) {
    if (!plugin.prototype || !plugin.prototype.constructor) {
      throw "Sortable: Mounted plugin must be a constructor function, not ".concat({}.toString.call(plugin));
    }
    if (plugin.utils) Sortable.utils = _objectSpread2(_objectSpread2({}, Sortable.utils), plugin.utils);
    PluginManager.mount(plugin);
  });
};

/**
 * Create sortable instance
 * @param {HTMLElement}  el
 * @param {Object}      [options]
 */
Sortable.create = function (el, options) {
  return new Sortable(el, options);
};

// Export
Sortable.version = version;

var drop = function drop(_ref) {
  var originalEvent = _ref.originalEvent,
    putSortable = _ref.putSortable,
    dragEl = _ref.dragEl,
    activeSortable = _ref.activeSortable,
    dispatchSortableEvent = _ref.dispatchSortableEvent,
    hideGhostForTarget = _ref.hideGhostForTarget,
    unhideGhostForTarget = _ref.unhideGhostForTarget;
  if (!originalEvent) return;
  var toSortable = putSortable || activeSortable;
  hideGhostForTarget();
  var touch = originalEvent.changedTouches && originalEvent.changedTouches.length ? originalEvent.changedTouches[0] : originalEvent;
  var target = document.elementFromPoint(touch.clientX, touch.clientY);
  unhideGhostForTarget();
  if (toSortable && !toSortable.el.contains(target)) {
    dispatchSortableEvent('spill');
    this.onSpill({
      dragEl: dragEl,
      putSortable: putSortable
    });
  }
};
function Revert() {}
Revert.prototype = {
  startIndex: null,
  dragStart: function dragStart(_ref2) {
    var oldDraggableIndex = _ref2.oldDraggableIndex;
    this.startIndex = oldDraggableIndex;
  },
  onSpill: function onSpill(_ref3) {
    var dragEl = _ref3.dragEl,
      putSortable = _ref3.putSortable;
    this.sortable.captureAnimationState();
    if (putSortable) {
      putSortable.captureAnimationState();
    }
    var nextSibling = getChild(this.sortable.el, this.startIndex, this.options);
    if (nextSibling) {
      this.sortable.el.insertBefore(dragEl, nextSibling);
    } else {
      this.sortable.el.appendChild(dragEl);
    }
    this.sortable.animateAll();
    if (putSortable) {
      putSortable.animateAll();
    }
  },
  drop: drop
};
_extends(Revert, {
  pluginName: 'revertOnSpill'
});
function Remove() {}
Remove.prototype = {
  onSpill: function onSpill(_ref4) {
    var dragEl = _ref4.dragEl,
      putSortable = _ref4.putSortable;
    var parentSortable = putSortable || this.sortable;
    parentSortable.captureAnimationState();
    dragEl.parentNode && dragEl.parentNode.removeChild(dragEl);
    parentSortable.animateAll();
  },
  drop: drop
};
_extends(Remove, {
  pluginName: 'removeOnSpill'
});

const bxfTabBarCss = "button.sc-bxf-tab-bar:hover,a.sc-bxf-tab-bar:hover,input[type=radio].sc-bxf-tab-bar:hover,input[type=checkbox].sc-bxf-tab-bar:hover,input[type=radio].sc-bxf-tab-bar:checked:hover,input[type=checkbox].sc-bxf-tab-bar:checked:hover,svg.sc-bxf-tab-bar:hover{cursor:pointer}svg[disabled].sc-bxf-tab-bar:hover,button[disabled].sc-bxf-tab-bar:hover,label[disabled].sc-bxf-tab-bar:hover,input[type=checkbox].sc-bxf-tab-bar:disabled:hover,input[type=radio].sc-bxf-tab-bar:disabled:hover,input[type=checkbox].sc-bxf-tab-bar:checked:disabled:hover,input[type=radio].sc-bxf-tab-bar:checked:disabled:hover{cursor:default}.bxf__assistive-text--hidden.sc-bxf-tab-bar{position:absolute !important;left:-625rem;top:auto;width:0.0625rem;height:0.0625rem;overflow:hidden}.oneds-blk-heading-display-1.sc-bxf-tab-bar{font-size:clamp(2.3675rem, 1.3308rem + 4.6074vw, 5.4775rem);line-height:1.22;word-wrap:break-word;font-weight:800;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif}@media (min-width: 37.5rem){.oneds-blk-heading-display-1.sc-bxf-tab-bar{line-height:1.21}}@media (min-width: 48rem){.oneds-blk-heading-display-1.sc-bxf-tab-bar{line-height:1.2}}@media (min-width: 64rem){.oneds-blk-heading-display-1.sc-bxf-tab-bar{line-height:1.18}}@media (min-width: 90rem){.oneds-blk-heading-display-1.sc-bxf-tab-bar{line-height:1.16}}.oneds-blk-heading-xxl.sc-bxf-tab-bar{font-size:clamp(2.0931rem, 1.3588rem + 3.2639vw, 4.2963rem);line-height:1.22;word-wrap:break-word;font-weight:800;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif}@media (min-width: 37.5rem){.oneds-blk-heading-xxl.sc-bxf-tab-bar{line-height:1.22}}@media (min-width: 48rem){.oneds-blk-heading-xxl.sc-bxf-tab-bar{line-height:1.21}}@media (min-width: 64rem){.oneds-blk-heading-xxl.sc-bxf-tab-bar{line-height:1.2}}@media (min-width: 90rem){.oneds-blk-heading-xxl.sc-bxf-tab-bar{line-height:1.18}}.oneds-blk-heading-xl.sc-bxf-tab-bar{font-size:clamp(1.8506rem, 1.3444rem + 2.25vw, 3.3694rem);line-height:1.23;word-wrap:break-word;font-weight:800;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif}@media (min-width: 37.5rem){.oneds-blk-heading-xl.sc-bxf-tab-bar{line-height:1.22}}@media (min-width: 48rem){.oneds-blk-heading-xl.sc-bxf-tab-bar{line-height:1.22}}@media (min-width: 64rem){.oneds-blk-heading-xl.sc-bxf-tab-bar{line-height:1.21}}@media (min-width: 90rem){.oneds-blk-heading-xl.sc-bxf-tab-bar{line-height:1.2}}.oneds-blk-heading-l.sc-bxf-tab-bar{font-size:clamp(1.6363rem, 1.3008rem + 1.4907vw, 2.6425rem);line-height:1.23;word-wrap:break-word;font-weight:800;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif}@media (min-width: 37.5rem){.oneds-blk-heading-l.sc-bxf-tab-bar{line-height:1.23}}@media (min-width: 48rem){.oneds-blk-heading-l.sc-bxf-tab-bar{line-height:1.23}}@media (min-width: 64rem){.oneds-blk-heading-l.sc-bxf-tab-bar{line-height:1.22}}@media (min-width: 90rem){.oneds-blk-heading-l.sc-bxf-tab-bar{line-height:1.21}}.oneds-blk-heading-m.sc-bxf-tab-bar{font-size:clamp(1.4469rem, 1.2383rem + 0.9269vw, 2.0725rem);line-height:1.24;word-wrap:break-word;font-weight:800;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif}@media (min-width: 37.5rem){.oneds-blk-heading-m.sc-bxf-tab-bar{line-height:1.23}}@media (min-width: 48rem){.oneds-blk-heading-m.sc-bxf-tab-bar{line-height:1.23}}@media (min-width: 64rem){.oneds-blk-heading-m.sc-bxf-tab-bar{line-height:1.23}}@media (min-width: 90rem){.oneds-blk-heading-m.sc-bxf-tab-bar{line-height:1.22}}.oneds-blk-heading-s.sc-bxf-tab-bar{font-size:clamp(1.2794rem, 1.164rem + 0.513vw, 1.6256rem);line-height:1.24;word-wrap:break-word;font-weight:800;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif}@media (min-width: 37.5rem){.oneds-blk-heading-s.sc-bxf-tab-bar{line-height:1.24}}@media (min-width: 48rem){.oneds-blk-heading-s.sc-bxf-tab-bar{line-height:1.24}}@media (min-width: 64rem){.oneds-blk-heading-s.sc-bxf-tab-bar{line-height:1.24}}@media (min-width: 90rem){.oneds-blk-heading-s.sc-bxf-tab-bar{line-height:1.23}}.oneds-blk-heading-xs.sc-bxf-tab-bar{font-size:clamp(1.1313rem, 1.0833rem + 0.213vw, 1.275rem);line-height:1.24;word-wrap:break-word;font-weight:800;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif}.oneds-blk-heading-xxs.sc-bxf-tab-bar{font-size:clamp(1rem, 1rem + 0vw, 1rem);line-height:1.25;word-wrap:break-word;font-weight:800;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif}.oneds-blk-eyebrow-l.sc-bxf-tab-bar{font-size:clamp(1rem, 1rem + 0vw, 1rem);line-height:1.27;word-wrap:break-word;font-weight:800;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif}.oneds-blk-eyebrow-m.sc-bxf-tab-bar{font-size:14px;line-height:1.3;word-wrap:break-word;font-weight:800;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif}.oneds-blk-eyebrow-s.sc-bxf-tab-bar{font-size:12px;line-height:1.34;word-wrap:break-word;font-weight:800;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif}.oneds-blk-body-xl.sc-bxf-tab-bar{font-size:clamp(1.2794rem, 1.164rem + 0.513vw, 1.6256rem);line-height:1.4;word-wrap:break-word;font-weight:400;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif}.oneds-blk-body-xl-bold.sc-bxf-tab-bar{font-size:clamp(1.2794rem, 1.164rem + 0.513vw, 1.6256rem);line-height:1.4;word-wrap:break-word;font-weight:700;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif}.oneds-blk-body-xl-italic.sc-bxf-tab-bar{font-size:clamp(1.2794rem, 1.164rem + 0.513vw, 1.6256rem);line-height:1.4;word-wrap:break-word;font-weight:400;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif;font-style:italic}.oneds-blk-body-xl-link.sc-bxf-tab-bar{font-size:clamp(1.2794rem, 1.164rem + 0.513vw, 1.6256rem);line-height:1.4;word-wrap:break-word;font-weight:700;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif;text-decoration:underline}.oneds-blk-body-l.sc-bxf-tab-bar{font-size:clamp(1.1313rem, 1.0833rem + 0.213vw, 1.275rem);line-height:1.45;word-wrap:break-word;font-weight:400;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif}.oneds-blk-body-l-bold.sc-bxf-tab-bar{font-size:clamp(1.1313rem, 1.0833rem + 0.213vw, 1.275rem);line-height:1.45;word-wrap:break-word;font-weight:700;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif}.oneds-blk-body-l-italic.sc-bxf-tab-bar{font-size:clamp(1.1313rem, 1.0833rem + 0.213vw, 1.275rem);line-height:1.45;word-wrap:break-word;font-weight:400;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif;font-style:italic}.oneds-blk-body-l-link.sc-bxf-tab-bar{font-size:clamp(1.1313rem, 1.0833rem + 0.213vw, 1.275rem);line-height:1.45;word-wrap:break-word;font-weight:700;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif;text-decoration:underline}.oneds-blk-body-m.sc-bxf-tab-bar{font-size:clamp(1rem, 1rem + 0vw, 1rem);line-height:1.5;word-wrap:break-word;font-weight:400;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif}.oneds-blk-body-m-bold.sc-bxf-tab-bar{font-size:clamp(1rem, 1rem + 0vw, 1rem);line-height:1.5;word-wrap:break-word;font-weight:700;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif}.oneds-blk-body-m-italic.sc-bxf-tab-bar{font-size:clamp(1rem, 1rem + 0vw, 1rem);line-height:1.5;word-wrap:break-word;font-weight:400;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif;font-style:italic}.oneds-blk-body-m-link.sc-bxf-tab-bar{font-size:clamp(1rem, 1rem + 0vw, 1rem);line-height:1.5;word-wrap:break-word;font-weight:700;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif;text-decoration:underline}.oneds-blk-body-m-compact.sc-bxf-tab-bar{font-size:clamp(1rem, 1rem + 0vw, 1rem);line-height:1.25;word-wrap:break-word;font-weight:400;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif}.oneds-blk-body-m-compact-bold.sc-bxf-tab-bar{font-size:clamp(1rem, 1rem + 0vw, 1rem);line-height:1.25;word-wrap:break-word;font-weight:700;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif}.oneds-blk-body-m-compact-italic.sc-bxf-tab-bar{font-size:clamp(1rem, 1rem + 0vw, 1rem);line-height:1.25;word-wrap:break-word;font-weight:400;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif;font-style:italic}.oneds-blk-body-m-compact-link.sc-bxf-tab-bar{font-size:clamp(1rem, 1rem + 0vw, 1rem);line-height:1.25;word-wrap:break-word;font-weight:700;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif;text-decoration:underline}.oneds-blk-body-s.sc-bxf-tab-bar{font-size:14px;line-height:1.5;word-wrap:break-word;font-weight:400;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif}.oneds-blk-body-s-bold.sc-bxf-tab-bar{font-size:14px;line-height:1.5;word-wrap:break-word;font-weight:700;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif}.oneds-blk-body-s-italic.sc-bxf-tab-bar{font-size:14px;line-height:1.5;word-wrap:break-word;font-weight:400;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif;font-style:italic}.oneds-blk-body-s-link.sc-bxf-tab-bar{font-size:14px;line-height:1.5;word-wrap:break-word;font-weight:700;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif;text-decoration:underline}.oneds-blk-body-s-compact.sc-bxf-tab-bar{font-size:14px;line-height:1.25;word-wrap:break-word;font-weight:400;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif}.oneds-blk-body-s-compact-bold.sc-bxf-tab-bar{font-size:14px;line-height:1.25;word-wrap:break-word;font-weight:700;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif}.oneds-blk-body-s-compact-italic.sc-bxf-tab-bar{font-size:14px;line-height:1.25;word-wrap:break-word;font-weight:400;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif;font-style:italic}.oneds-blk-body-s-compact-link.sc-bxf-tab-bar{font-size:14px;line-height:1.25;word-wrap:break-word;font-weight:700;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif;text-decoration:underline}.oneds-blk-body-xs.sc-bxf-tab-bar{font-size:12px;line-height:1.5;word-wrap:break-word;font-weight:400;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif}.oneds-blk-body-xs-bold.sc-bxf-tab-bar{font-size:12px;line-height:1.5;word-wrap:break-word;font-weight:700;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif}.oneds-blk-body-xs-italic.sc-bxf-tab-bar{font-size:12px;line-height:1.5;word-wrap:break-word;font-weight:400;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif;font-style:italic}.oneds-blk-body-xs-link.sc-bxf-tab-bar{font-size:12px;line-height:1.5;word-wrap:break-word;font-weight:700;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif;text-decoration:underline}.oneds-blk-body-xs-compact.sc-bxf-tab-bar{font-size:12px;line-height:1.25;word-wrap:break-word;font-weight:400;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif}.oneds-blk-body-xs-compact-bold.sc-bxf-tab-bar{font-size:12px;line-height:1.25;word-wrap:break-word;font-weight:700;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif}.oneds-blk-body-xs-compact-italic.sc-bxf-tab-bar{font-size:12px;line-height:1.25;word-wrap:break-word;font-weight:400;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif;font-style:italic}.oneds-blk-body-xs-compact-link.sc-bxf-tab-bar{font-size:12px;line-height:1.25;word-wrap:break-word;font-weight:700;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif;text-decoration:underline}.oneds-richTextEditorOutput.sc-bxf-tab-bar h1.sc-bxf-tab-bar,.oneds-richTextEditorOutput.sc-bxf-tab-bar h1.sc-bxf-tab-bar strong.sc-bxf-tab-bar,.oneds-richTextEditorOutput.sc-bxf-tab-bar h1.sc-bxf-tab-bar em.sc-bxf-tab-bar,.oneds-richTextEditorOutput.sc-bxf-tab-bar h1.sc-bxf-tab-bar a.sc-bxf-tab-bar{font-size:clamp(2.0931rem, 1.3588rem + 3.2639vw, 4.2963rem);line-height:1.22;word-wrap:break-word;font-weight:800;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif;padding:var(--oneds-space-fluid-m) 0 var(--oneds-space-fluid-m) 0}@media (min-width: 37.5rem){.oneds-richTextEditorOutput.sc-bxf-tab-bar h1.sc-bxf-tab-bar,.oneds-richTextEditorOutput.sc-bxf-tab-bar h1.sc-bxf-tab-bar strong.sc-bxf-tab-bar,.oneds-richTextEditorOutput.sc-bxf-tab-bar h1.sc-bxf-tab-bar em.sc-bxf-tab-bar,.oneds-richTextEditorOutput.sc-bxf-tab-bar h1.sc-bxf-tab-bar a.sc-bxf-tab-bar{line-height:1.22}}@media (min-width: 48rem){.oneds-richTextEditorOutput.sc-bxf-tab-bar h1.sc-bxf-tab-bar,.oneds-richTextEditorOutput.sc-bxf-tab-bar h1.sc-bxf-tab-bar strong.sc-bxf-tab-bar,.oneds-richTextEditorOutput.sc-bxf-tab-bar h1.sc-bxf-tab-bar em.sc-bxf-tab-bar,.oneds-richTextEditorOutput.sc-bxf-tab-bar h1.sc-bxf-tab-bar a.sc-bxf-tab-bar{line-height:1.21}}@media (min-width: 64rem){.oneds-richTextEditorOutput.sc-bxf-tab-bar h1.sc-bxf-tab-bar,.oneds-richTextEditorOutput.sc-bxf-tab-bar h1.sc-bxf-tab-bar strong.sc-bxf-tab-bar,.oneds-richTextEditorOutput.sc-bxf-tab-bar h1.sc-bxf-tab-bar em.sc-bxf-tab-bar,.oneds-richTextEditorOutput.sc-bxf-tab-bar h1.sc-bxf-tab-bar a.sc-bxf-tab-bar{line-height:1.2}}@media (min-width: 90rem){.oneds-richTextEditorOutput.sc-bxf-tab-bar h1.sc-bxf-tab-bar,.oneds-richTextEditorOutput.sc-bxf-tab-bar h1.sc-bxf-tab-bar strong.sc-bxf-tab-bar,.oneds-richTextEditorOutput.sc-bxf-tab-bar h1.sc-bxf-tab-bar em.sc-bxf-tab-bar,.oneds-richTextEditorOutput.sc-bxf-tab-bar h1.sc-bxf-tab-bar a.sc-bxf-tab-bar{line-height:1.18}}.oneds-richTextEditorOutput.sc-bxf-tab-bar h1.sc-bxf-tab-bar a.sc-bxf-tab-bar:focus-visible,.oneds-richTextEditorOutput.sc-bxf-tab-bar h1.sc-bxf-tab-bar strong.sc-bxf-tab-bar a.sc-bxf-tab-bar:focus-visible,.oneds-richTextEditorOutput.sc-bxf-tab-bar h1.sc-bxf-tab-bar em.sc-bxf-tab-bar a.sc-bxf-tab-bar:focus-visible,.oneds-richTextEditorOutput.sc-bxf-tab-bar h1.sc-bxf-tab-bar a.sc-bxf-tab-bar a.sc-bxf-tab-bar:focus-visible{background-clip:content-box}.oneds-richTextEditorOutput.sc-bxf-tab-bar h2.sc-bxf-tab-bar,.oneds-richTextEditorOutput.sc-bxf-tab-bar h2.sc-bxf-tab-bar strong.sc-bxf-tab-bar,.oneds-richTextEditorOutput.sc-bxf-tab-bar h2.sc-bxf-tab-bar em.sc-bxf-tab-bar,.oneds-richTextEditorOutput.sc-bxf-tab-bar h2.sc-bxf-tab-bar a.sc-bxf-tab-bar{font-size:clamp(1.8506rem, 1.3444rem + 2.25vw, 3.3694rem);line-height:1.23;word-wrap:break-word;font-weight:800;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif;padding:var(--oneds-space-fluid-s) 0 var(--oneds-space-fluid-m) 0}@media (min-width: 37.5rem){.oneds-richTextEditorOutput.sc-bxf-tab-bar h2.sc-bxf-tab-bar,.oneds-richTextEditorOutput.sc-bxf-tab-bar h2.sc-bxf-tab-bar strong.sc-bxf-tab-bar,.oneds-richTextEditorOutput.sc-bxf-tab-bar h2.sc-bxf-tab-bar em.sc-bxf-tab-bar,.oneds-richTextEditorOutput.sc-bxf-tab-bar h2.sc-bxf-tab-bar a.sc-bxf-tab-bar{line-height:1.22}}@media (min-width: 48rem){.oneds-richTextEditorOutput.sc-bxf-tab-bar h2.sc-bxf-tab-bar,.oneds-richTextEditorOutput.sc-bxf-tab-bar h2.sc-bxf-tab-bar strong.sc-bxf-tab-bar,.oneds-richTextEditorOutput.sc-bxf-tab-bar h2.sc-bxf-tab-bar em.sc-bxf-tab-bar,.oneds-richTextEditorOutput.sc-bxf-tab-bar h2.sc-bxf-tab-bar a.sc-bxf-tab-bar{line-height:1.22}}@media (min-width: 64rem){.oneds-richTextEditorOutput.sc-bxf-tab-bar h2.sc-bxf-tab-bar,.oneds-richTextEditorOutput.sc-bxf-tab-bar h2.sc-bxf-tab-bar strong.sc-bxf-tab-bar,.oneds-richTextEditorOutput.sc-bxf-tab-bar h2.sc-bxf-tab-bar em.sc-bxf-tab-bar,.oneds-richTextEditorOutput.sc-bxf-tab-bar h2.sc-bxf-tab-bar a.sc-bxf-tab-bar{line-height:1.21}}@media (min-width: 90rem){.oneds-richTextEditorOutput.sc-bxf-tab-bar h2.sc-bxf-tab-bar,.oneds-richTextEditorOutput.sc-bxf-tab-bar h2.sc-bxf-tab-bar strong.sc-bxf-tab-bar,.oneds-richTextEditorOutput.sc-bxf-tab-bar h2.sc-bxf-tab-bar em.sc-bxf-tab-bar,.oneds-richTextEditorOutput.sc-bxf-tab-bar h2.sc-bxf-tab-bar a.sc-bxf-tab-bar{line-height:1.2}}.oneds-richTextEditorOutput.sc-bxf-tab-bar h2.sc-bxf-tab-bar a.sc-bxf-tab-bar:focus-visible,.oneds-richTextEditorOutput.sc-bxf-tab-bar h2.sc-bxf-tab-bar strong.sc-bxf-tab-bar a.sc-bxf-tab-bar:focus-visible,.oneds-richTextEditorOutput.sc-bxf-tab-bar h2.sc-bxf-tab-bar em.sc-bxf-tab-bar a.sc-bxf-tab-bar:focus-visible,.oneds-richTextEditorOutput.sc-bxf-tab-bar h2.sc-bxf-tab-bar a.sc-bxf-tab-bar a.sc-bxf-tab-bar:focus-visible{background-clip:content-box}.oneds-richTextEditorOutput.sc-bxf-tab-bar h3.sc-bxf-tab-bar,.oneds-richTextEditorOutput.sc-bxf-tab-bar h3.sc-bxf-tab-bar strong.sc-bxf-tab-bar,.oneds-richTextEditorOutput.sc-bxf-tab-bar h3.sc-bxf-tab-bar em.sc-bxf-tab-bar,.oneds-richTextEditorOutput.sc-bxf-tab-bar h3.sc-bxf-tab-bar a.sc-bxf-tab-bar{font-size:clamp(1.6363rem, 1.3008rem + 1.4907vw, 2.6425rem);line-height:1.23;word-wrap:break-word;font-weight:800;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif;padding:var(--oneds-space-fluid-xs) 0 var(--oneds-space-fluid-s) 0}@media (min-width: 37.5rem){.oneds-richTextEditorOutput.sc-bxf-tab-bar h3.sc-bxf-tab-bar,.oneds-richTextEditorOutput.sc-bxf-tab-bar h3.sc-bxf-tab-bar strong.sc-bxf-tab-bar,.oneds-richTextEditorOutput.sc-bxf-tab-bar h3.sc-bxf-tab-bar em.sc-bxf-tab-bar,.oneds-richTextEditorOutput.sc-bxf-tab-bar h3.sc-bxf-tab-bar a.sc-bxf-tab-bar{line-height:1.23}}@media (min-width: 48rem){.oneds-richTextEditorOutput.sc-bxf-tab-bar h3.sc-bxf-tab-bar,.oneds-richTextEditorOutput.sc-bxf-tab-bar h3.sc-bxf-tab-bar strong.sc-bxf-tab-bar,.oneds-richTextEditorOutput.sc-bxf-tab-bar h3.sc-bxf-tab-bar em.sc-bxf-tab-bar,.oneds-richTextEditorOutput.sc-bxf-tab-bar h3.sc-bxf-tab-bar a.sc-bxf-tab-bar{line-height:1.23}}@media (min-width: 64rem){.oneds-richTextEditorOutput.sc-bxf-tab-bar h3.sc-bxf-tab-bar,.oneds-richTextEditorOutput.sc-bxf-tab-bar h3.sc-bxf-tab-bar strong.sc-bxf-tab-bar,.oneds-richTextEditorOutput.sc-bxf-tab-bar h3.sc-bxf-tab-bar em.sc-bxf-tab-bar,.oneds-richTextEditorOutput.sc-bxf-tab-bar h3.sc-bxf-tab-bar a.sc-bxf-tab-bar{line-height:1.22}}@media (min-width: 90rem){.oneds-richTextEditorOutput.sc-bxf-tab-bar h3.sc-bxf-tab-bar,.oneds-richTextEditorOutput.sc-bxf-tab-bar h3.sc-bxf-tab-bar strong.sc-bxf-tab-bar,.oneds-richTextEditorOutput.sc-bxf-tab-bar h3.sc-bxf-tab-bar em.sc-bxf-tab-bar,.oneds-richTextEditorOutput.sc-bxf-tab-bar h3.sc-bxf-tab-bar a.sc-bxf-tab-bar{line-height:1.21}}.oneds-richTextEditorOutput.sc-bxf-tab-bar h3.sc-bxf-tab-bar a.sc-bxf-tab-bar:focus-visible,.oneds-richTextEditorOutput.sc-bxf-tab-bar h3.sc-bxf-tab-bar strong.sc-bxf-tab-bar a.sc-bxf-tab-bar:focus-visible,.oneds-richTextEditorOutput.sc-bxf-tab-bar h3.sc-bxf-tab-bar em.sc-bxf-tab-bar a.sc-bxf-tab-bar:focus-visible,.oneds-richTextEditorOutput.sc-bxf-tab-bar h3.sc-bxf-tab-bar a.sc-bxf-tab-bar a.sc-bxf-tab-bar:focus-visible{background-clip:content-box}.oneds-richTextEditorOutput.sc-bxf-tab-bar h4.sc-bxf-tab-bar,.oneds-richTextEditorOutput.sc-bxf-tab-bar h4.sc-bxf-tab-bar strong.sc-bxf-tab-bar,.oneds-richTextEditorOutput.sc-bxf-tab-bar h4.sc-bxf-tab-bar em.sc-bxf-tab-bar,.oneds-richTextEditorOutput.sc-bxf-tab-bar h4.sc-bxf-tab-bar a.sc-bxf-tab-bar{font-size:clamp(1.4469rem, 1.2383rem + 0.9269vw, 2.0725rem);line-height:1.24;word-wrap:break-word;font-weight:800;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif;padding:var(--oneds-space-fluid-xxs) 0 var(--oneds-space-fluid-xs) 0}@media (min-width: 37.5rem){.oneds-richTextEditorOutput.sc-bxf-tab-bar h4.sc-bxf-tab-bar,.oneds-richTextEditorOutput.sc-bxf-tab-bar h4.sc-bxf-tab-bar strong.sc-bxf-tab-bar,.oneds-richTextEditorOutput.sc-bxf-tab-bar h4.sc-bxf-tab-bar em.sc-bxf-tab-bar,.oneds-richTextEditorOutput.sc-bxf-tab-bar h4.sc-bxf-tab-bar a.sc-bxf-tab-bar{line-height:1.23}}@media (min-width: 48rem){.oneds-richTextEditorOutput.sc-bxf-tab-bar h4.sc-bxf-tab-bar,.oneds-richTextEditorOutput.sc-bxf-tab-bar h4.sc-bxf-tab-bar strong.sc-bxf-tab-bar,.oneds-richTextEditorOutput.sc-bxf-tab-bar h4.sc-bxf-tab-bar em.sc-bxf-tab-bar,.oneds-richTextEditorOutput.sc-bxf-tab-bar h4.sc-bxf-tab-bar a.sc-bxf-tab-bar{line-height:1.23}}@media (min-width: 64rem){.oneds-richTextEditorOutput.sc-bxf-tab-bar h4.sc-bxf-tab-bar,.oneds-richTextEditorOutput.sc-bxf-tab-bar h4.sc-bxf-tab-bar strong.sc-bxf-tab-bar,.oneds-richTextEditorOutput.sc-bxf-tab-bar h4.sc-bxf-tab-bar em.sc-bxf-tab-bar,.oneds-richTextEditorOutput.sc-bxf-tab-bar h4.sc-bxf-tab-bar a.sc-bxf-tab-bar{line-height:1.23}}@media (min-width: 90rem){.oneds-richTextEditorOutput.sc-bxf-tab-bar h4.sc-bxf-tab-bar,.oneds-richTextEditorOutput.sc-bxf-tab-bar h4.sc-bxf-tab-bar strong.sc-bxf-tab-bar,.oneds-richTextEditorOutput.sc-bxf-tab-bar h4.sc-bxf-tab-bar em.sc-bxf-tab-bar,.oneds-richTextEditorOutput.sc-bxf-tab-bar h4.sc-bxf-tab-bar a.sc-bxf-tab-bar{line-height:1.22}}.oneds-richTextEditorOutput.sc-bxf-tab-bar h4.sc-bxf-tab-bar a.sc-bxf-tab-bar:focus-visible,.oneds-richTextEditorOutput.sc-bxf-tab-bar h4.sc-bxf-tab-bar strong.sc-bxf-tab-bar a.sc-bxf-tab-bar:focus-visible,.oneds-richTextEditorOutput.sc-bxf-tab-bar h4.sc-bxf-tab-bar em.sc-bxf-tab-bar a.sc-bxf-tab-bar:focus-visible,.oneds-richTextEditorOutput.sc-bxf-tab-bar h4.sc-bxf-tab-bar a.sc-bxf-tab-bar a.sc-bxf-tab-bar:focus-visible{background-clip:content-box}.oneds-richTextEditorOutput.sc-bxf-tab-bar h5.sc-bxf-tab-bar,.oneds-richTextEditorOutput.sc-bxf-tab-bar h5.sc-bxf-tab-bar strong.sc-bxf-tab-bar,.oneds-richTextEditorOutput.sc-bxf-tab-bar h5.sc-bxf-tab-bar em.sc-bxf-tab-bar,.oneds-richTextEditorOutput.sc-bxf-tab-bar h5.sc-bxf-tab-bar a.sc-bxf-tab-bar{font-size:clamp(1.2794rem, 1.164rem + 0.513vw, 1.6256rem);line-height:1.24;word-wrap:break-word;font-weight:800;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif;padding:var(--oneds-space-fluid-xxxs) 0 var(--oneds-space-fluid-xxs) 0}@media (min-width: 37.5rem){.oneds-richTextEditorOutput.sc-bxf-tab-bar h5.sc-bxf-tab-bar,.oneds-richTextEditorOutput.sc-bxf-tab-bar h5.sc-bxf-tab-bar strong.sc-bxf-tab-bar,.oneds-richTextEditorOutput.sc-bxf-tab-bar h5.sc-bxf-tab-bar em.sc-bxf-tab-bar,.oneds-richTextEditorOutput.sc-bxf-tab-bar h5.sc-bxf-tab-bar a.sc-bxf-tab-bar{line-height:1.24}}@media (min-width: 48rem){.oneds-richTextEditorOutput.sc-bxf-tab-bar h5.sc-bxf-tab-bar,.oneds-richTextEditorOutput.sc-bxf-tab-bar h5.sc-bxf-tab-bar strong.sc-bxf-tab-bar,.oneds-richTextEditorOutput.sc-bxf-tab-bar h5.sc-bxf-tab-bar em.sc-bxf-tab-bar,.oneds-richTextEditorOutput.sc-bxf-tab-bar h5.sc-bxf-tab-bar a.sc-bxf-tab-bar{line-height:1.24}}@media (min-width: 64rem){.oneds-richTextEditorOutput.sc-bxf-tab-bar h5.sc-bxf-tab-bar,.oneds-richTextEditorOutput.sc-bxf-tab-bar h5.sc-bxf-tab-bar strong.sc-bxf-tab-bar,.oneds-richTextEditorOutput.sc-bxf-tab-bar h5.sc-bxf-tab-bar em.sc-bxf-tab-bar,.oneds-richTextEditorOutput.sc-bxf-tab-bar h5.sc-bxf-tab-bar a.sc-bxf-tab-bar{line-height:1.24}}@media (min-width: 90rem){.oneds-richTextEditorOutput.sc-bxf-tab-bar h5.sc-bxf-tab-bar,.oneds-richTextEditorOutput.sc-bxf-tab-bar h5.sc-bxf-tab-bar strong.sc-bxf-tab-bar,.oneds-richTextEditorOutput.sc-bxf-tab-bar h5.sc-bxf-tab-bar em.sc-bxf-tab-bar,.oneds-richTextEditorOutput.sc-bxf-tab-bar h5.sc-bxf-tab-bar a.sc-bxf-tab-bar{line-height:1.23}}.oneds-richTextEditorOutput.sc-bxf-tab-bar h5.sc-bxf-tab-bar a.sc-bxf-tab-bar:focus-visible,.oneds-richTextEditorOutput.sc-bxf-tab-bar h5.sc-bxf-tab-bar strong.sc-bxf-tab-bar a.sc-bxf-tab-bar:focus-visible,.oneds-richTextEditorOutput.sc-bxf-tab-bar h5.sc-bxf-tab-bar em.sc-bxf-tab-bar a.sc-bxf-tab-bar:focus-visible,.oneds-richTextEditorOutput.sc-bxf-tab-bar h5.sc-bxf-tab-bar a.sc-bxf-tab-bar a.sc-bxf-tab-bar:focus-visible{background-clip:content-box}.oneds-richTextEditorOutput.sc-bxf-tab-bar h6.sc-bxf-tab-bar,.oneds-richTextEditorOutput.sc-bxf-tab-bar h6.sc-bxf-tab-bar strong.sc-bxf-tab-bar,.oneds-richTextEditorOutput.sc-bxf-tab-bar h6.sc-bxf-tab-bar em.sc-bxf-tab-bar,.oneds-richTextEditorOutput.sc-bxf-tab-bar h6.sc-bxf-tab-bar a.sc-bxf-tab-bar{font-size:clamp(1rem, 1rem + 0vw, 1rem);line-height:1.25;word-wrap:break-word;font-weight:800;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif;padding-bottom:var(--oneds-space-xxs)}.oneds-richTextEditorOutput.sc-bxf-tab-bar h6.sc-bxf-tab-bar a.sc-bxf-tab-bar:focus-visible,.oneds-richTextEditorOutput.sc-bxf-tab-bar h6.sc-bxf-tab-bar strong.sc-bxf-tab-bar a.sc-bxf-tab-bar:focus-visible,.oneds-richTextEditorOutput.sc-bxf-tab-bar h6.sc-bxf-tab-bar em.sc-bxf-tab-bar a.sc-bxf-tab-bar:focus-visible,.oneds-richTextEditorOutput.sc-bxf-tab-bar h6.sc-bxf-tab-bar a.sc-bxf-tab-bar a.sc-bxf-tab-bar:focus-visible{background-clip:content-box}.oneds-richTextEditorOutput.sc-bxf-tab-bar p.sc-bxf-tab-bar{font-size:clamp(1rem, 1rem + 0vw, 1rem);line-height:1.5;word-wrap:break-word;font-weight:400;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif;padding-bottom:var(--oneds-space-m)}.oneds-richTextEditorOutput.sc-bxf-tab-bar ul.sc-bxf-tab-bar,.oneds-richTextEditorOutput.sc-bxf-tab-bar ol.sc-bxf-tab-bar{font-size:clamp(1rem, 1rem + 0vw, 1rem);line-height:1.5;word-wrap:break-word;font-weight:400;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif;padding:0 0 var(--oneds-space-m) var(--oneds-space-m);list-style-type:revert}.oneds-richTextEditorOutput.sc-bxf-tab-bar ul.sc-bxf-tab-bar li.sc-bxf-tab-bar:not(:last-child),.oneds-richTextEditorOutput.sc-bxf-tab-bar ol.sc-bxf-tab-bar li.sc-bxf-tab-bar:not(:last-child){padding-bottom:var(--oneds-space-m)}.oneds-richTextEditorOutput.sc-bxf-tab-bar strong.sc-bxf-tab-bar{font-size:clamp(1rem, 1rem + 0vw, 1rem);line-height:1.5;word-wrap:break-word;font-weight:700;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif;padding-bottom:var(--oneds-space-m)}.oneds-richTextEditorOutput.sc-bxf-tab-bar em.sc-bxf-tab-bar{font-size:clamp(1rem, 1rem + 0vw, 1rem);line-height:1.5;word-wrap:break-word;font-weight:400;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif;font-style:italic;padding-bottom:var(--oneds-space-m)}.oneds-richTextEditorOutput.sc-bxf-tab-bar a.sc-bxf-tab-bar{font-size:clamp(1rem, 1rem + 0vw, 1rem);line-height:1.5;word-wrap:break-word;font-weight:700;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif;text-decoration:underline;color:var(--oneds-text-default);text-decoration:underline;text-decoration-thickness:2px;text-underline-offset:3px;transition:text-decoration 300ms ease-out}.oneds-richTextEditorOutput.sc-bxf-tab-bar .mce-content-body.sc-bxf-tab-bar [data-mce-selected=inline-boundary].sc-bxf-tab-bar{background-clip:content-box}.oneds-richTextEditorOutput.sc-bxf-tab-bar a.sc-bxf-tab-bar:hover,.oneds-richTextEditorOutput.sc-bxf-tab-bar a.sc-bxf-tab-bar:active{text-decoration:underline;text-decoration-thickness:4px;transition:text-decoration 100ms ease-out}.oneds-richTextEditorOutput.sc-bxf-tab-bar a.sc-bxf-tab-bar:focus-visible{background:var(--oneds-bg-black);color:var(--oneds-text-inverse);text-decoration:none;border:none;outline:none;border-radius:0}.oneds-richTextEditorOutput.oneds-bg-black.sc-bxf-tab-bar a.sc-bxf-tab-bar{color:var(--oneds-text-inverse)}.oneds-richTextEditorOutput.oneds-bg-black.sc-bxf-tab-bar a.sc-bxf-tab-bar:focus-visible{background:var(--oneds-bg-white);color:var(--oneds-text-default);text-decoration:none;border:none;outline:none;border-radius:0}.oneds-richTextEditorOutput.sc-bxf-tab-bar sub.sc-bxf-tab-bar,.oneds-richTextEditorOutput.sc-bxf-tab-bar sup.sc-bxf-tab-bar{line-height:0}.bxf-tab-bar__container.sc-bxf-tab-bar{display:flex;width:100%;height:100%;align-items:center;justify-content:space-between}.bxf-tab-bar__container-empty.sc-bxf-tab-bar{border-bottom:solid 0.0625rem #d9d6ce;display:flex;height:32px;margin-top:-0.046875rem}.bxf-tab-bar__container--tabs.sc-bxf-tab-bar{display:flex;min-width:0;height:100%}.bxf-tab-bar__tabs-container.sc-bxf-tab-bar{display:flex;overflow-x:scroll;box-sizing:border-box;height:100%;position:relative}.bxf-tab-bar__tabs-container--classic.sc-bxf-tab-bar{border-right:solid 0.0625rem #d9d6ce}.bxf-tab-bar__tab-container--scrolling-left.sc-bxf-tab-bar{border-left:solid 0.0625rem #d9d6ce}.bxf-tab-bar__tab-container--scrolling-right.sc-bxf-tab-bar{border-right:solid 0.0625rem #d9d6ce}.bxf-tab-bar__tabs-container.sc-bxf-tab-bar::-webkit-scrollbar{-webkit-appearance:none;display:none}.bxf-tab-bar__pinned-tabs-container.sc-bxf-tab-bar{display:flex;flex-shrink:0;height:100%;border-right:solid 0.0625rem #d9d6ce;box-sizing:border-box}.bxf-tab-bar__add-icon-container.sc-bxf-tab-bar,.bxf-tab-bar__add-icon-container--modern.sc-bxf-tab-bar,.bxf-tab-bar__add-icon-container--empty.sc-bxf-tab-bar{display:flex;align-items:center;justify-content:center;height:32px;min-width:32px;box-sizing:border-box;border:none;border-bottom:solid 0.0625rem #d9d6ce;border-right:solid 0.0625rem #d9d6ce;border-top:solid 0.0625rem #d9d6ce;background-color:#f9f7f5;font-size:0.8125rem;font-family:inherit;color:#000000;white-space:nowrap;padding-right:1rem;padding-left:1rem}.bxf-tab-bar__add-icon-container.sc-bxf-tab-bar:focus,.bxf-tab-bar__add-icon-container--modern.sc-bxf-tab-bar:focus,.bxf-tab-bar__add-icon-container--empty.sc-bxf-tab-bar:focus{outline:0.0625rem dotted var(--primary-action__color);outline:auto var(--primary-action__color)}.bxf-tab-bar__add-icon-container.bxf__focus--keyboard-only.sc-bxf-tab-bar:focus:not(:focus-visible),.bxf__focus--keyboard-only.bxf-tab-bar__add-icon-container--modern.sc-bxf-tab-bar:focus:not(:focus-visible),.bxf__focus--keyboard-only.bxf-tab-bar__add-icon-container--empty.sc-bxf-tab-bar:focus:not(:focus-visible){outline:0}.bxf-tab-bar__add-icon-container.sc-bxf-tab-bar:hover,.bxf-tab-bar__add-icon-container--modern.sc-bxf-tab-bar:hover,.bxf-tab-bar__add-icon-container--empty.sc-bxf-tab-bar:hover{background-color:#ff47130F}.bxf-tab-bar__add-icon-container.sc-bxf-tab-bar:hover .bxf-tab__span.sc-bxf-tab-bar,.bxf-tab-bar__add-icon-container--modern.sc-bxf-tab-bar:hover .bxf-tab__span.sc-bxf-tab-bar,.bxf-tab-bar__add-icon-container--empty.sc-bxf-tab-bar:hover .bxf-tab__span.sc-bxf-tab-bar{color:var(--primary-action__color)}.bxf-tab-bar__add-icon-container--empty.sc-bxf-tab-bar{border-left:solid 0.0625rem #d9d6ce}.bxf-tab-bar__add-icon-container--modern.sc-bxf-tab-bar{border-right:none;border-top:none;border-left:none;background-color:transparent}.bxf-tab-bar__navigation-icon-container.sc-bxf-tab-bar,.bxf-tab-bar__navigation-icon-container-with-border-bottom.sc-bxf-tab-bar{display:flex;align-items:center;justify-content:center;height:32px}.bxf-tab-bar__navigation-icon-container-with-border-bottom.sc-bxf-tab-bar{border-bottom:solid 0.0625rem #d9d6ce;margin-top:-0.0625rem}.bxf-tab-bar__tab-bar-item-drag--ghost.sc-bxf-tab-bar{opacity:0.5}.bxf-tab__add-button--label.sc-bxf-tab-bar{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;padding-left:8px}@media (forced-colors: active){.bxf-tab-bar__add-icon-container.sc-bxf-tab-bar,.bxf-tab-bar__add-icon-container--empty.sc-bxf-tab-bar,.bxf-tab-bar__add-icon-container--modern.sc-bxf-tab-bar{border-color:CanvasText}}";
const BxfTabBarStyle0 = bxfTabBarCss;

const { TAB_TYPE_CLASSIC, TAB_TYPE_MODERN, WIDTH_TYPE_TRUNCATED, TIMER_PRESS_DELAY, RESIZE_DEBOUNCE_DELAY, TIMER_PRESS_REPEAT, SCROLL, SCROLL_FACTOR, PINNED_TABS_CONTAINER, TABS_CONTAINER, LEFT_NAV_ICON, RIGHT_NAV_ICON, ICON_STATE, UID, TAG_NAME, ADD_ICON_CONTAINER, ADD_ICON_CONTAINER_MODERN, ADD_ICON_CONTAINER_CLASSIC, ADD_BUTTON_ICON, ADD_ICON_SPAN, CONTAINER, CONTAINER_TABS, BOTTOM_BORDER_DIV, NAV_BUTTONS, NAV_BUTTONS_BOTTOM_BORDER, TABS_SCROLLING_LEFT, TABS_SCROLLING_RIGHT, DRAG_GHOST, LEFT_NAV_LABEL, RIGHT_NAV_LABEL, ADD_TAB_LABEL, BXF_TAB_BAR_ITEM, ADD_ICON_CONTAINER_EMPTY, } = BxfTabBarConstants;
const BxfTabBar = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.tabBarItemAdded = createEvent(this, "tabBarItemAdded", 7);
        this.tabBarItemDeleted = createEvent(this, "tabBarItemDeleted", 7);
        this.tabBarItemRenamed = createEvent(this, "tabBarItemRenamed", 7);
        this.tabBarItemSelected = createEvent(this, "tabBarItemSelected", 7);
        this.tabBarItemPinned = createEvent(this, "tabBarItemPinned", 7);
        this.tabBarItemDragged = createEvent(this, "tabBarItemDragged", 7);
        this.tabBarAddIconClicked = createEvent(this, "tabBarAddIconClicked", 7);
        this.tabBarItemIconClicked = createEvent(this, "tabBarItemIconClicked", 7);
        this.namespaceI18n = undefined;
        this.i18nKeys = undefined;
        this.data = [];
        this.activeUid = undefined;
        this.tabType = TAB_TYPE_CLASSIC;
        this.widthType = WIDTH_TYPE_TRUNCATED;
        this.deletableType = BxfTabBarDeletableTypeEnum.DELETABLE_ADDABLE;
        this.isEditable = false;
        this.isRenameable = false;
        this.isDraggable = false;
        this.isDeletable = false;
        this.isPinnable = false;
        this.scrollToActive = false;
        this.label = '';
        this.addButtonLabel = '';
        this.keepMouseFocus = false;
        this.dataTestSuffix = undefined;
        this.isTracking = true;
        this.trackingData = undefined;
        this.hasNavigation = true;
        this.hasBottomBorder = false;
        this.selectCallback = undefined;
        this.customPadding = undefined;
        this.backNavDisabled = true;
        this.nextNavDisabled = true;
        this.focusSource = FocusSource.Keyboard;
        this.focusableUid = undefined;
        this.ariaAddWithoutLabel = ADD_TAB_LABEL;
        this.scrollLeftLabel = LEFT_NAV_LABEL;
        this.scrollRightLabel = RIGHT_NAV_LABEL;
    }
    get containerHost() { return getElement(this); }
    // #region "Private Variables"
    /**
     * Tab bar container for tab section (includes pinned tabs, tabs, nav buttons, add icon)
     */
    _tabBarContainerRef;
    /**
     * Tab bar container for main tab section (not including pinned tabs, nav buttons, add icon)
     */
    _tabBarItemContainerRef;
    _tabBarBottomBorderDivRef;
    /**
     * Tab bar add button
     */
    _tabBarAddButtonRef;
    /**
     * Determines when tab group has fully initialized. Used to distinguish between preloaded tab bar items and any changes
     * that may happen after the initial load.
     */
    _tabGroupLoaded = false;
    /**
     * Local copy of data, used to differentiate new items and existing items for event handling
     */
    _data = [];
    /**
     * Contains the config for all frozen tab bar items passed in through the data prop
     * Used to determine rendering of pinned tab bar item section
     */
    _frozenTabBarItems = [];
    /**
     * Contains the config for all pinned tab bar items passed in through the data prop
     * Used to determine rendering of pinned tab bar item section
     */
    _pinnedTabBarItems = [];
    /**
     * Contains the config for all the tab bar items (unpinned) passed in through the data prop
     * Used to determine rendering of main tab bar item section
     */
    _tabBarItems = [];
    /**
     * The current selected tab bar item
     */
    _selectedTabBarItem;
    /**
     * Resize observer handler
     * Needed to keep reference to listener and remove on component disconnect
     */
    _tabBarItemContainerResizeObserver;
    /**
     * Scroll amount for navigation buttons
     */
    _discreteScrollAmount;
    /**
     * Time in ms for when to start continuously scrolling after holding buttons
     */
    _navTimerAmount = TIMER_PRESS_DELAY;
    /**
     * setTimeout timer reference for nav buttons
     * Needed to clear the timer to avoid memory leaks
     */
    _navTimer;
    /**
     * Reference to the sortablejs object and configs
     */
    _sortableObject;
    /**
     * Special case for when tab bar item is pinned.
     * Should execute the initialization of dragging once again in componentDidUpdate
     */
    _executePin = false;
    /**
     * Special case for keyboard reorder
     */
    _executeReorder = false;
    /**
     * Special case for editable/draggable changing
     */
    _editableChanged = false;
    /**
     * Uid of tab to focus after rerender
     */
    _tabUidToFocus = '';
    /**
     * Used to track whether or not a tab is being edited
     */
    _tabBarItemEditing = false;
    /**
     * Stores the most recently added tab
     */
    _newlyAddedTab;
    /**
     * Stores the button type for the navigation buttons
     */
    _navigationButtonsType = BxfButtonTypeEnum.TERTIARY;
    /**
     * Used to track whether new tab caused overflow
     */
    _newTabCausedOverflow = false;
    /**
     * Used to track if the second render is occurring that
     * realigns the new tab that caused the overflow
     */
    _newTabNeedsRealigned = 0;
    /**
     * Enables translation
     */
    i18n;
    /**
     * Used to track editable actions (rename, draggable, deletable/addable, pinnable)
     */
    _isEditable = false;
    // #endregion "Props"
    // #region "Events"
    /**
     * This event is called when the tab bar item is created
     */
    tabBarItemAdded;
    /**
     * This event is called when a tab bar item is deleted
     */
    tabBarItemDeleted;
    /**
     * This event is called when a tab bar item is renamed
     */
    tabBarItemRenamed;
    /**
     * This event is called when a tab is selected
     */
    tabBarItemSelected;
    /**
     * This event is called when a tab is pinned
     */
    tabBarItemPinned;
    /**
     * This event is called when a tab is dragged
     */
    tabBarItemDragged;
    /**
     * This event is called when the Add icon is clicked
     */
    tabBarAddIconClicked;
    /**
     * This event is called when a tab bar action button is clicked
     */
    tabBarItemIconClicked;
    // #endregion "States"
    // #region "Listeners"
    /**
     * Event listener for tab bar item component when tab bar item is selected
     *
     * @param event tab bar item component selected event
     */
    async onSelectTabBarItemHandler(event) {
        const tabSelected = event.detail.tab;
        this._selectedTabBarItem = tabSelected;
        // If tab bar item is slightly cut off, will bring it fully into view
        this.scrollItemIntoView();
        this.tabBarItemSelected.emit({
            srcEvent: event,
            eventData: tabSelected.eventData,
            uid: tabSelected.uid,
            tab: tabSelected,
        });
    }
    /**
     * Event listener for tab bar item component when tab bar item is created
     *
     * @param event tab bar item component created event
     */
    onNewTabBarItemCreated(event) {
        const { tab, uid } = event.detail; // Destructuring event.detail to get tab and uid
        // Checks to see if tab bar item already exists using uid
        const exists = this._data.findIndex((el) => el.uid === uid);
        // If exists and _newlyAddedTab not set by dataChanged
        if (exists > -1 && !this._newlyAddedTab) {
            return;
        }
        this._newlyAddedTab = tab;
        // Setting the selected tab bar item
        /* istanbul ignore else */
        if (tab.isSelected) {
            this._selectedTabBarItem = tab;
        }
        if (this._tabGroupLoaded) {
            // Setting copy of local data to new data for future comparisons
            this._data = _.cloneDeep(this.data); // Need to reset this for further use in tracking newly added tabs
            // Need to reset this for further use in tracking newly added tabs
            this._tabUidToFocus = uid;
            // An item has been added to double check overflow navigation
            this.onResizeHandler();
            this.tabBarItemAdded.emit({
                srcEvent: event,
                eventData: tab.eventData,
                uid,
                tab,
            });
            // Scroll the new tab into view
            requestAnimationFrame(() => {
                this.scrollItemIntoView(this._newlyAddedTab);
                this._newlyAddedTab = null; // Reset newly added tab after ensuring it is scrolled into view
            });
        }
    }
    /**
     * Event listener for tab bar item component when tab bar item is deleted
     * Simply emits delete event, no delete logic is run within the component
     * This will be taken care of by dev teams when they update their data array.
     *
     * @param event tab bar item component deleted event
     */
    async onDeleteTabBarItemHandler(event) {
        // Logic for suggesting a new active uid if the tab deleted is selected
        // Default to the current selected uid
        let suggestedActiveUid = this.activeUid;
        const idx = this.data.findIndex((el) => el.uid === event.detail.uid);
        // Only suggest something different if the tab deleted is currently selected
        // Okay the way this will work is that it will suggest the next tab
        // This is similar to how Google Chrome tabs works
        if (event.detail.tab.isSelected && this.data.length > 1) {
            if (this.data[idx + 1]?.isDisabled && this.data[idx + 2]) {
                suggestedActiveUid = this.data[idx + 2]?.uid;
            }
            else if (idx >= this.data.length - 1) {
                // Special case if selected tab is the last tab
                // Need to offset the index by two
                suggestedActiveUid = this.data[this.data.length - 2].uid;
            }
            else {
                suggestedActiveUid = this.data[idx + 1].uid;
            }
        }
        // Should set the focus to the next tab
        /* istanbul ignore else */
        if (this._data.length > 1) {
            this._tabUidToFocus = suggestedActiveUid;
        }
        else {
            this._tabBarAddButtonRef?.focus();
        }
        this.tabBarItemDeleted.emit({
            srcEvent: event,
            eventData: event.detail.eventData,
            uid: event.detail.uid,
            tab: event.detail.tab,
            suggestedActiveUid,
        });
    }
    /**
     * Event is triggered when a tab bar item is currently being edited
     *
     * @param event tab bar item component editing event
     */
    onEditingTabBarItemHandler(event) {
        this._tabBarItemEditing = event.detail.isEditing;
    }
    /**
     * Event listener for tab bar item component when tab bar item label has been edited
     *
     * @param event tab bar item edited event
     */
    onEditTabBarItemHandler(event) {
        const exists = this.data.findIndex((el) => el.uid === event.detail.uid);
        if (exists > -1) {
            this.data[exists].label = event.detail.newLabel;
        }
        this.tabBarItemRenamed.emit({
            srcEvent: event,
            eventData: event.detail.eventData,
            uid: event.detail.uid,
            tab: event.detail.tab,
            oldLabel: event.detail.oldLabel,
            newLabel: event.detail.newLabel,
        });
    }
    /**
     * Event listener for tab bar item component when tab bar item label has been edited
     * Simply emits pinned event, no pin logic is run within the component
     * This will be taken care of by the dev teams when they update their data array
     *
     * @param event tab bar item edited event
     */
    onPinTabBarItemHandler(event) {
        this._executePin = true;
        this._tabUidToFocus = event.detail.uid;
        this.tabBarItemPinned.emit({
            srcEvent: event,
            eventData: event.detail.eventData,
            uid: event.detail.uid,
            tab: event.detail.tab,
            pinned: event.detail.pinned,
        });
    }
    /**
     * Event listener for tab bar item component when action button is clicked within tab bar item
     *
     * @param event tab bar item action button event
     */
    onActionIconClickedHandler(event) {
        this.tabBarItemIconClicked.emit({
            srcEvent: event,
            eventData: event.detail.eventData,
            icon: event.detail.icon,
        });
    }
    /**
     * Handles roving tabindex logic
     * Left/Right Keys -> navigate items by one
     * Home -> Goes back to first item
     * End -> Goes to the last item
     *
     * @param event keyboard event for keydown listener
     */
    handleKeydown(event) {
        // All the keyboard keys that can control tab bar items
        const navKeys = [
            ...FocusIndexManager.HORIZONTAL_NAV_KEYS,
            KeyboardEventKey.Home,
            KeyboardEventKey.End,
        ];
        // Handles the nav key selection logic
        if (navKeys.includes(event.key) &&
            !this._tabBarItemEditing) {
            this.navKeyHandler(event);
        }
        else if ((this.isEditable || this._isEditable) &&
            event.shiftKey &&
            (event.ctrlKey || event.metaKey)) {
            // handle reorder on ctrl/cmd+shift+pageup/pagedn
            this.handleKeyboardReorder(event);
        }
    }
    onFocusedHandler(event) {
        if (this.focusableUid !== event.detail.uid) {
            this.focusableUid = event.detail.uid;
        }
    }
    mouseDownHandler(event) {
        event.stopPropagation();
    }
    // #endregion "Listeners"
    // #region "Watchers"
    /**
     * Separating pinned and unpinned tabs to help determine component structure and rendering needs
     */
    dataChanged(newValue, oldValue) {
        // Data hasn't changed so no update necessary
        if (_.isEqual(oldValue, newValue)) {
            return;
        }
        let filteredArray = [];
        // Need to store newly added tab for use in onNewTabBarItemCreated()
        /* istanbul ignore else */
        if (this._data && this.data) {
            if (this._data.length > this.data.length) {
                // case where item is deleted
                filteredArray = this._data.filter((x) => !this.data.includes(x));
            }
            else {
                // case where item is added
                filteredArray = this.data.filter((x) => !this._data.includes(x));
            }
        }
        /* istanbul ignore else */
        if (filteredArray.length) {
            this._newlyAddedTab = filteredArray[0];
        }
        this._data = newValue;
        this._frozenTabBarItems = [];
        this._pinnedTabBarItems = [];
        this._tabBarItems = [];
        this.data?.forEach((item) => this.addTabBarItem(item));
    }
    editableChanged(newValue, oldValue) {
        /* istanbul ignore else */
        if (newValue !== oldValue) {
            this._editableChanged = true;
            this.setEditable();
        }
    }
    // #endregion "Watchers"
    // #region "Methods"
    /**
     * Exposed method for developers to scroll the selected tab bar item into view
     * If a tab bar item is provided, then will scroll to the specified tab bar item
     *
     * @param element if specified, will scroll into view within tab bar
     */
    async updateScrollPosition(element) {
        const el = element || this._selectedTabBarItem;
        /* istanbul ignore else */
        if (el && this._tabBarItemContainerRef) {
            const scrollAmount = el.offsetLeft - 1;
            this._tabBarItemContainerRef.scrollLeft = scrollAmount;
        }
        else {
            console.warn('[BXF TAB BAR] Could not scroll because no scrollable element found');
        }
    }
    /**
     * Will scroll a certain item into view if it is currently out of view or slightly cut off
     * Used for selecting a tab which is slightly cut off to bring it fully into view
     *
     * @param element if specified, will scroll into view
     */
    async scrollItemIntoView(element) {
        const el = element || this._selectedTabBarItem;
        // Getting the max x value within the container taking into account width and current scroll amount
        const containerBoundsRight = this._tabBarItemContainerRef.clientWidth +
            this._tabBarItemContainerRef.scrollLeft;
        // Getting the max x value of the tab bar item taking into account width and scroll offset amount
        const itemBoundsRight = Math.floor(el.getBoundingClientRect().width + el.offsetLeft);
        // Only run scroll logic if the tab bar item is scrolled out of view
        if (itemBoundsRight > containerBoundsRight) {
            // Right hand side
            const scrollLeft = el.getBoundingClientRect().width +
                el.offsetLeft -
                this._tabBarItemContainerRef.clientWidth;
            this._tabBarItemContainerRef.scrollLeft = scrollLeft;
        }
        else if (el.offsetLeft < this._tabBarItemContainerRef.scrollLeft) {
            // Left hand side
            this._tabBarItemContainerRef.scrollLeft = el.offsetLeft;
        }
    }
    /**
     * Move focus to a tab given its uid.
     * @param uid uid of tab to focus
     * @param scrollIntoView whether or not to scroll tab into view
     */
    async focusTabWithUid(uid, scrollIntoView = false) {
        if (this.focusableUid !== uid) {
            this.focusableUid = uid;
        }
        const tabItem = this.getTabWithUid(uid);
        /* istanbul ignore else */
        if (tabItem) {
            await tabItem.focusTab();
            if (scrollIntoView && !tabItem.isFrozen && !tabItem.isPinned) {
                this.scrollItemIntoView(tabItem);
            }
        }
    }
    // #endregion "Methods"
    // #region "Main Code"
    componentWillLoad() {
        if (isUsingI18n() && this.namespaceI18n) {
            this.initI18n();
        }
        // Binding functions
        this.onAddButtonClicked = this.onAddButtonClicked.bind(this);
        this.onScrollHandler = this.onScrollHandler.bind(this);
        this.backNavHoldHandler = this.backNavHoldHandler.bind(this);
        this.nextNavHoldHandler = this.nextNavHoldHandler.bind(this);
        this.navHoldDoneHandler = this.navHoldDoneHandler.bind(this);
        this.repeat = this.repeat.bind(this);
        this.keyboardClick = this.keyboardClick.bind(this);
        this.setEditable();
        // Separating pinned and unpinned tabs to help determine component structure and rendering needs
        this.dataChanged(this.data, []);
    }
    componentDidLoad() {
        this._tabGroupLoaded = true;
        // Initializing overflow if needed, setTimeout needed to ensure correct running order
        setTimeout(() => this.tabBarComponentOnReady());
        // Draggable logic leveraging sortablejs
        if (this._tabBarItemContainerRef) {
            this.initializeDragging();
        }
        // Adding resize observer to handle recalculation of the scroll navigation
        // The resize listener is probably the most resource intensive part of the component
        if (this._tabBarItemContainerRef) {
            this.initTabGroupResizeObserver();
        }
        this.focusableUid = this.activeUid;
        if (this.hasBottomBorder) {
            this._tabBarBottomBorderDivRef.style.setProperty('width', `calc(100% - ${this._tabBarContainerRef.getBoundingClientRect().width - 6}px)`);
        }
    }
    async componentDidUpdate() {
        if (this._tabUidToFocus) {
            await this.focusTabWithUid(this._tabUidToFocus, this._executePin || this._executeReorder);
            this._tabUidToFocus = '';
        }
        if (this._tabBarItemContainerRef &&
            (this._executePin || this._editableChanged)) {
            this.initializeDragging();
        }
        if (this._executePin) {
            this._executePin = false;
        }
        if (this._executeReorder) {
            this._executeReorder = false;
        }
        if (this._editableChanged) {
            this._editableChanged = false;
        }
    }
    disconnectedCallback() {
        // We need to make sure to remove this observer so that we don't run into memory leaks and performance issues
        if (this._tabBarItemContainerResizeObserver) {
            this._tabBarItemContainerResizeObserver.disconnect();
        }
        this.i18n?.destroyTranslations();
    }
    initI18n() {
        this.i18n = new BxfI18n(this.namespaceI18n);
        window['i18n'].on('languageChanged', () => {
            this.i18n.languageChangedHandler(this.translateText());
        });
        window['i18n'].on('loaded', () => {
            this.translateText();
        });
    }
    translateText() {
        translateKeys(this, this.i18nKeys, this.i18n);
        this.data.forEach((element) => {
            translateKeys(element, element.i18nKeys, this.i18n);
        });
    }
    /**
     * Handle adding a tab bar item. Account for frozen/pinned tabs
     */
    addTabBarItem(item) {
        if (item.isFrozen || (item.isPinned && !this.isPinningEnabled())) {
            this._frozenTabBarItems.push(item);
        }
        else if (item.isPinned && this.isPinningEnabled()) {
            this._pinnedTabBarItems.push(item);
        }
        else {
            this._tabBarItems.push(item);
        }
    }
    setEditable() {
        if (this.isEditable) {
            this.isRenameable = false;
            this.isDraggable = false;
            this.isDeletable = false;
            this.isPinnable = false;
            this._isEditable = false;
        }
        else {
            this._isEditable =
                this.isRenameable ||
                    this.isDraggable ||
                    this.isDeletable ||
                    this.isPinnable;
        }
    }
    /**
     * Reorder a tab on Ctrl+Shift+PageUp/Down if it meets the following conditions:
     * - Tab group is not empty
     * - Tab group contains draggable, visible tabs
     * - Tab group is draggable
     * - Keyboard event is coming from tab in tab group
     * - Tab is not pinned
     */
    handleKeyboardReorder(event) {
        /* istanbul ignore else */
        if (event.key === KeyboardEventKey.PageUp ||
            event.key === KeyboardEventKey.PageDown) {
            const path = eventPath(event);
            /* istanbul ignore else */
            if (path) {
                const tabElem = _.find(path, (el) => _.get(el, TAG_NAME, '').toLowerCase() ===
                    BXF_TAB_BAR_ITEM &&
                    _.find(this._tabBarItems, (item) => item.uid === el.uid));
                if (!tabElem) {
                    return;
                }
                /* istanbul ignore else */
                if (!tabElem.isFrozen && !tabElem.isPinned) {
                    this.reorderTabsOnKeyDown(event, `${tabElem.uid}`);
                }
            }
        }
    }
    /**
     * Reorder tab in draggableTabs based on keyboard event (page up/down).
     */
    reorderTabsOnKeyDown(event, tabUid) {
        const focusedTabIndex = _.findIndex(this._tabBarItems, (el) => _.get(el, UID, '') === tabUid);
        let swapIndex = -1;
        if (event.key === KeyboardEventKey.PageUp) {
            swapIndex = focusedTabIndex - 1;
            /* istanbul ignore else */
        }
        else if (focusedTabIndex !== this._tabBarItems.length - 1) {
            swapIndex = focusedTabIndex + 1;
        }
        /* istanbul ignore else */
        if (swapIndex > -1) {
            this.swapTabs(event, tabUid, this._tabBarItems[swapIndex].uid);
        }
    }
    /**
     * Given a specific uid, get the bxf-tab-bar-item element with uid
     */
    getTabWithUid(uid) {
        return this._tabBarContainerRef.querySelector(`${BXF_TAB_BAR_ITEM}[${UID}="${uid}"]`);
    }
    /**
     * Based on a keyboard event, swap tab at focusedTabIndex with tab at swapIndex.
     */
    swapTabs(event, tabUid, swapUid) {
        event.preventDefault();
        const focusedTabIndex = _.findIndex(this.data, (el) => el.uid === tabUid);
        const swapIndex = _.findIndex(this.data, (el) => el.uid === swapUid);
        const tabToFocus = this.getTabWithUid(tabUid);
        this._tabUidToFocus = tabUid;
        this._executeReorder = true;
        this.tabBarItemDragged.emit({
            srcEvent: event,
            eventData: tabToFocus.eventData,
            uid: tabToFocus.uid,
            tab: tabToFocus,
            oldIndex: focusedTabIndex,
            newIndex: swapIndex,
        });
    }
    /**
     * Method that initializes ResizeObserver for _tabBarItemContainerRef.
     * Has a debounce so that it is triggered only once after a certain delay in resizing
     * This will only trigger when the _tabBarItemContainerRef container is resized
     * Triggers should be: renaming causing change, adding, deleting, resizing window, maybe dragging?
     * Pinning will also trigger this due to the double border being added :(
     */
    initTabGroupResizeObserver() {
        this._tabBarItemContainerResizeObserver =
            new /* istanbul ignore next */ ResizeObserver(_.debounce(() => this.onResizeHandler(), RESIZE_DEBOUNCE_DELAY));
        this._tabBarItemContainerResizeObserver.observe(this._tabBarItemContainerRef);
    }
    /**
     * Needs to happen in the componentOnReady lifecycle to ensure scroll calculations run correctly
     * This will also scroll to selected tab if overflow is present
     */
    tabBarComponentOnReady() {
        this.containerHost.componentOnReady().then(() => {
            this.onResizeHandler();
            if (this.scrollToActive)
                this.updateScrollPosition();
        });
    }
    /**
     * Initializes the sortablejs object with specific config
     * Also takes care of the dragEnd event emitter
     */
    initializeDragging() {
        if (this._sortableObject) {
            this._sortableObject.destroy();
            // prevent destroying sortable object twice
            this._sortableObject = null;
        }
        if (!(this.isEditable || this.isDraggable)) {
            return;
        }
        this._sortableObject = new /* istanbul ignore next */ Sortable(this._tabBarItemContainerRef, {
            // ms, animation speed moving items when sorting, `0` — without animation
            animation: 50,
            // Class name for the drop placeholder
            ghostClass: DRAG_GHOST,
            // Threshold of the swap zone. Will only swap after crossing middle half of element
            swapThreshold: 0.5,
            // Disables dragging for disabled tabs
            filter: '.disabled',
            // Element dragging ended
            onEnd: (evt) => {
                this.tabBarItemDragged.emit({
                    srcEvent: evt,
                    eventData: evt.item.eventData,
                    uid: evt.item.uid,
                    tab: evt.item,
                    oldIndex: evt.oldIndex,
                    newIndex: evt.newIndex,
                });
            },
        });
    }
    /**
     * Click handler for add icon button
     * Does not actually add a tab, instead simply emits an event
     * that the button was clicked.
     */
    onAddButtonClicked(event) {
        this.tabBarAddIconClicked.emit({
            srcEvent: event,
            eventData: undefined,
        });
    }
    /**
     * Performs manual scrolling based on button navigation
     *
     * @param backButton Determines back or forward scrolling
     */
    navClickHandler(backButton) {
        const scrollAmount = backButton
            ? this._discreteScrollAmount * -1
            : this._discreteScrollAmount;
        this._tabBarItemContainerRef.scrollLeft += scrollAmount;
    }
    /**
     * [CLICK AND HOLD LOGIC]
     * Click and hold handler for back nav button
     * Entrance point for the repeat logic.
     */
    backNavHoldHandler() {
        this.repeat(true);
    }
    /**
     * [CLICK AND HOLD LOGIC]
     * Click and hold handler for next nav button
     * Entrance point for the repeat logic.
     */
    nextNavHoldHandler() {
        this.repeat(false);
    }
    /**
     * [CLICK AND HOLD LOGIC]
     * Stops the click and hold logic/timer executing in repeat()
     * Should be called on mouseUp, mouseOut, and when the buttons are disabled.
     */
    navHoldDoneHandler() {
        clearTimeout(this._navTimer);
        // Resetting delay amount back to initial amount of 1 second
        this._navTimerAmount = TIMER_PRESS_DELAY;
    }
    /**
     * [CLICK AND HOLD LOGIC]
     * Special case for keyboard: leveraging button click event
     * Will only trigger on button click from keyboard
     *
     * @param event mouse event from click event
     * @param backButton differentiates between back and next button
     */
    keyboardClick(event, backButton) {
        event.stopPropagation();
        // This differentiates between keyboard and click event
        // Will be 0 if from keyboard, otherwise will be 1 or greater if from mouse
        if (event.detail >= 1) {
            return;
        }
        // This will only run if keyboard click
        this.navClickHandler(backButton);
    }
    /**
     * [CLICK AND HOLD LOGIC]
     * Main repeat logic for click and hold pattern for nav buttons
     * Sets time out logic to begin executing after _navTimerAmount
     * After initial delay, will then continue to run this at a rate of
     * 10ms every execution.
     *
     * Only stops once navHoldDoneHandler() is called
     *
     * @param backButton determines which nav button handler to execute
     */
    repeat(backButton) {
        this.navClickHandler(backButton);
        // Keep this in mind as a potential performance hit
        this._navTimer = setTimeout(this.repeat, this._navTimerAmount, backButton);
        // This is needed to execute faster after the initial 1 second delay
        this._navTimerAmount = TIMER_PRESS_REPEAT;
    }
    /**
     * [OVERFLOW LOGIC]
     * Main function handling the resizing logic for tab bar overflow
     * Should take care of determining whether or not to enable/disable nav buttons
     * based on resizing.
     * Additional logic will need to run to determined which buttons to be enabled.
     * This function may get overloaded and called too many times, we need to make sure
     * this is only being called when necessary (which may end up being quite a bit)
     */
    onResizeHandler() {
        // This will only happen if we are currently rendering pinned tabs since the normal tab
        // container doesn't exist yet
        if (!this._tabBarItemContainerRef) {
            return;
        }
        // Case where there is scroll in the main tab bar div
        if (this._tabBarItemContainerRef.scrollWidth >
            this._tabBarItemContainerRef.clientWidth) {
            // This is the extra logic to determine which buttons to enable/disable
            this.determineNavButtonStates();
            this.setScrollListeners(true);
            // Setting the manual scroll amount for navigation buttons
            this._discreteScrollAmount = this.setDiscreteScrollAmount();
        }
        // Case where there is no scroll in the main tab bar div
        else {
            // Resetting the state variables for the buttons
            this.nextNavDisabled = true;
            this.backNavDisabled = true;
            this.setScrollListeners(false);
        }
    }
    /**
     * [OVERFLOW LOGIC]
     * Calculates the discrete scrolling amount for navigation buttons
     * This number should be fine tuned by UX guidelines/feedback
     * Most likely this will always be a *magic* number
     */
    setDiscreteScrollAmount() {
        return Math.ceil(this._tabBarItemContainerRef.scrollWidth * SCROLL_FACTOR);
    }
    /**
     * [OVERFLOW LOGIC]
     * Adds or removes the event listener for scrolling within the main tab bar
     *
     * @param add controls whether to add or remove the event listener
     */
    setScrollListeners(add) {
        if (add) {
            this._tabBarItemContainerRef.addEventListener(SCROLL, this.onScrollHandler);
        }
        else {
            this._tabBarItemContainerRef.removeEventListener(SCROLL, this.onScrollHandler);
        }
    }
    /**
     * [OVERFLOW LOGIC]
     * Handles scrolling for main tab bar section.
     * Main entry point for scrolling to determine states of nav buttons
     */
    onScrollHandler() {
        this.determineNavButtonStates();
    }
    /**
     * [OVERFLOW LOGIC]
     * Controls the state of the nav buttons determined by scrolling
     * This can get triggered either by resizing or scrolling or navigation buttons
     */
    determineNavButtonStates() {
        // Amount of scroll to the left. Value of zero means cannot scroll left anymore
        const { scrollLeft } = this._tabBarItemContainerRef;
        // Amount of scroll to the right. Value of zero means cannot scroll to the right anymore
        const scrollRight = this._tabBarItemContainerRef.scrollWidth -
            Math.ceil(this._tabBarItemContainerRef.scrollLeft) -
            this._tabBarItemContainerRef.clientWidth;
        // Logic for back button state
        // Enabled based on if there is horizontal scroll to the left
        // Disabled based on if there is no horizontal scroll to the left
        if (scrollLeft > 0) {
            this.backNavDisabled = false;
            // If Classic Style Adds divider line to the scrolling area so that there is clear boundary of tabs scrolling behind something
            // If Modern Style remove divider if it exist
            /* istanbul ignore next: unreachable code - ADD_ICON_CONTAINER_MODERN applied to add button */
            if (this._tabBarItemContainerRef.classList.contains(ADD_ICON_CONTAINER_MODERN)) {
                this._tabBarItemContainerRef.classList.add(TABS_SCROLLING_LEFT);
            } /* istanbul ignore next: unreachable code - ADD_ICON_CONTAINER_MODERN applied to add button, scrolling class never added */
            else if (this._tabBarItemContainerRef.classList.contains(TABS_SCROLLING_LEFT)) {
                this._tabBarItemContainerRef.classList.remove(TABS_SCROLLING_LEFT);
            }
        }
        else {
            // This is needed because once button is disabled, the mouseLeave event is not fired
            // Causing the hold logic in repeat() to never reset
            this.navHoldDoneHandler();
            this.backNavDisabled = true;
            // If exists removes divider line to the scrolling area to avoid double borders in Classic Style
            /* istanbul ignore next: unreachable code - ADD_ICON_CONTAINER_MODERN applied to add button, scrolling class never added */
            if (this._tabBarItemContainerRef.classList.contains(TABS_SCROLLING_LEFT)) {
                this._tabBarItemContainerRef.classList.remove(TABS_SCROLLING_LEFT);
            }
        }
        // Logic for next button state
        // Enabled based on if there is horizontal scroll to the right
        // Disabled based on if there is no horizontal scroll to the right
        if (scrollRight > 1) {
            // Logic to determine if the new tab initiated overflow
            this._newTabCausedOverflow =
                this.backNavDisabled && this.nextNavDisabled;
            this.nextNavDisabled = false;
            // Adds divider line to the scrolling area so that there is clear boundary of tabs scrolling behind something
            /* istanbul ignore next: unreachable code - ADD_ICON_CONTAINER_MODERN applied to add button */
            if (this._tabBarItemContainerRef.classList.contains(ADD_ICON_CONTAINER_MODERN)) {
                this._tabBarItemContainerRef.classList.add(TABS_SCROLLING_RIGHT);
            } /* istanbul ignore next: unreachable code - ADD_ICON_CONTAINER_MODERN applied to add button, scrolling class never added */
            else if (this._tabBarItemContainerRef.classList.contains(TABS_SCROLLING_RIGHT)) {
                this._tabBarItemContainerRef.classList.remove(TABS_SCROLLING_RIGHT);
            }
        }
        else {
            // This is needed because once button is disabled, the mouseLeave event is not fired
            // Causing the hold logic in repeat() to never reset
            this.navHoldDoneHandler();
            this.nextNavDisabled = true;
            // Removes divider line to the scrolling area to avoid double borders
            /* istanbul ignore next: unreachable code - ADD_ICON_CONTAINER_MODERN applied to add button, scrolling class never added */
            if (this._tabBarItemContainerRef.classList.contains(TABS_SCROLLING_RIGHT)) {
                this._tabBarItemContainerRef.classList.remove(TABS_SCROLLING_RIGHT);
            }
        }
    }
    /**
     * [ACCESSIBILITY LOGIC]
     * Handles the navigation keys for the roving tab index
     * This is what shows the focus ring when using right and left arrow keys
     *
     * @param event keyboard event
     */
    navKeyHandler(event) {
        // Need an array of all tab bar items
        const focusableTabs = Array.from(this._tabBarContainerRef.querySelectorAll(BXF_TAB_BAR_ITEM));
        const activeIndex = this.getIndexOfActiveTab(focusableTabs);
        /* istanbul ignore else */
        if (activeIndex !== -1) {
            // This check is needed because of the call in onDeleteTabBarItemHandler() which mocks the keyboard event
            /* istanbul ignore else */
            if (event.preventDefault && event.stopPropagation) {
                event.preventDefault();
                event.stopPropagation(); // stop computation in nested tabs
            }
            // Index of next tab to be focused
            const focusIndex = FocusIndexManager.getFocusIndexForNavEvent(focusableTabs, activeIndex, event);
            // Next focusable tab
            const tabToFocus = focusableTabs[focusIndex];
            /* istanbul ignore else */
            if (this.focusableUid !== tabToFocus.uid) {
                this._tabUidToFocus = tabToFocus.uid;
                this.focusableUid = tabToFocus.uid;
                // update current focused tab to not be focusable (needed for slots)
                const currentFocusedTab = focusableTabs[activeIndex];
                currentFocusedTab.isTabFocused = false;
                currentFocusedTab.isTabFocusable = false;
            }
        }
    }
    /**
     * [ACCESSIBILITY LOGIC]
     * Finds the current activeElement index of the tab bar
     * activeElement is needed to determine which tab bar item has the focus
     *
     * @param tabs list of focusable tab bar items
     */
    getIndexOfActiveTab(tabs) {
        return tabs.findIndex((tab) => this.containerHost.querySelector('bxf-tab-bar-item') === tab);
    }
    /**
     * Returns aria config for buttons
     *
     * @param label aria label
     * @param disabled disabled state
     */
    getAriaConfig(label) {
        return {
            title: label,
        };
    }
    // #endregion "Main Code"
    // #region "CSS Getters"
    /**
     * Returns css for left icon button
     */
    get addIconButtonCss() {
        const tabType = this.tabType === TAB_TYPE_MODERN ? ADD_ICON_CONTAINER_MODERN : '';
        const addIconState = this._tabBarItems.length > 0
            ? ADD_ICON_CONTAINER
            : ADD_ICON_CONTAINER_EMPTY;
        return getKeyboardFocusCSS(`${addIconState} ${tabType}`, this.keepMouseFocus);
    }
    get tabsContainerButtonCss() {
        const tabType = this.tabType === TAB_TYPE_CLASSIC ? ADD_ICON_CONTAINER_CLASSIC : '';
        return `${TABS_CONTAINER} ${tabType}`;
    }
    // #endregion "CSS Getters"
    // #region "Render"
    // Renders an individual tab bar item to be leveraged for both pinned and unpinned tabs
    renderTabBarItem(item, index, isPinned = false) {
        // A key is needed here to identify each tab uniquely to the browser
        // Without a key, the deletion of a tab will not work as expected
        // Reference: https://reactjs.org/docs/lists-and-keys.html#keys
        const tabBarItemUid = `${item.uid}`;
        const prefix = index < 10 ? '0' : '';
        const { namespaceI18n } = this;
        const itemI18nKeys = item.i18nKeys;
        return (h("bxf-tab-bar-item", { namespaceI18n: namespaceI18n, i18nKeys: itemI18nKeys, key: tabBarItemUid, label: item.label, uid: tabBarItemUid, "is-editable": this.isEditable, "is-renameable": this.isRenameable, "is-deletable": this.isDeletable, "is-pinnable": this.isPinnable, "is-pinned": isPinned, "is-disabled": item.isDisabled, "is-frozen": item.isFrozen || (item.isPinned && !this.isPinningEnabled()),
            // Needs to be camelCase or else eventData of type 'object' will be undefined
            eventData: item.eventData, "width-type": this.widthType, "tab-type": this.tabType, "is-selected": tabBarItemUid === this.activeUid, "is-tab-focusable": tabBarItemUid === this.focusableUid, "button-slot": item.buttonSlot,
            // No clue why this needs to be camelCase, but it wont work otherwise
            badgeSlot: item.badgeSlot, keepMouseFocus: this.keepMouseFocus, selectCallback: this.selectCallback, dataTestSuffix: createSelector(`${prefix}${index}`, this.dataTestSuffix, true) }));
    }
    /**
     * Returns whether pinned tabs should be frozen or pinned
     */
    isPinningEnabled() {
        return this.isEditable || this.isPinnable;
    }
    renderPinnedTabs() {
        if (_.isEmpty(this._pinnedTabBarItems) &&
            _.isEmpty(this._frozenTabBarItems)) {
            return null;
        }
        const tabPinnedElements = [];
        [...this._frozenTabBarItems, ...this._pinnedTabBarItems].forEach((item, index) => {
            tabPinnedElements.push(this.renderTabBarItem(item, index, !item.isFrozen && this.isPinningEnabled()));
        });
        return (h("div", { role: Role.PRESENTATION, class: PINNED_TABS_CONTAINER }, tabPinnedElements));
    }
    // HELPER FUNCTION
    // Sets reference for the tab bar container
    handleRef(el) {
        /* istanbul ignore else */
        if (el) {
            this._tabBarItemContainerRef = el;
        }
    }
    renderTabs() {
        if (_.isEmpty(this._tabBarItems)) {
            return null;
        }
        const tabElements = [];
        this._tabBarItems.forEach((item, index) => {
            tabElements.push(this.renderTabBarItem(item, index));
        });
        return (h("div", { role: Role.PRESENTATION, class: this.tabsContainerButtonCss, ref: (el) => this.handleRef(el) }, tabElements));
    }
    renderOverflowNavigation() {
        if (this._newTabCausedOverflow) {
            this.updateScrollPosition();
            if (this._newTabCausedOverflow) {
                this._newTabNeedsRealigned++;
            }
            if (this._newTabNeedsRealigned > 1) {
                this._newTabCausedOverflow = false;
                this._newTabNeedsRealigned = 0;
            }
        }
        if (this.hasNavigation &&
            !(this.backNavDisabled && this.nextNavDisabled)) {
            return [
                h("bxf-button", { key: '00', assistiveText: this.scrollLeftLabel, ariaConfig: this.getAriaConfig(this.scrollLeftLabel), class: this.hasBottomBorder
                        ? NAV_BUTTONS_BOTTOM_BORDER
                        : NAV_BUTTONS, icon: LEFT_NAV_ICON, type: this._navigationButtonsType, "is-disabled": this.backNavDisabled, onMouseDown: this.backNavHoldHandler, onMouseUp: this.navHoldDoneHandler, onMouseLeave: this.navHoldDoneHandler, keepMouseFocus: this.keepMouseFocus, dataTestSuffix: createSelector('00', this.dataTestSuffix, true), onClick: (event) => this.keyboardClick(event, true) }),
                h("bxf-button", { key: '01', assistiveText: this.scrollRightLabel, ariaConfig: this.getAriaConfig(this.scrollRightLabel), class: this.hasBottomBorder
                        ? NAV_BUTTONS_BOTTOM_BORDER
                        : NAV_BUTTONS, icon: RIGHT_NAV_ICON, type: this._navigationButtonsType, "is-disabled": this.nextNavDisabled, onMouseDown: this.nextNavHoldHandler, onMouseUp: this.navHoldDoneHandler, onMouseLeave: this.navHoldDoneHandler, keepMouseFocus: this.keepMouseFocus, dataTestSuffix: createSelector('01', this.dataTestSuffix, true), onClick: (event) => this.keyboardClick(event, false) }),
            ];
        }
        return [];
    }
    ariaLabelValue() {
        if (this.addButtonLabel) {
            return null;
        }
        return this.label
            ? `Add Tab to ${this.label}`
            : this.ariaAddWithoutLabel;
    }
    renderAddButton() {
        return ((this.isEditable ||
            (this.isDeletable &&
                this.deletableType ===
                    BxfTabBarDeletableTypeEnum.DELETABLE_ADDABLE)) && (h("button", { ref: (el) => {
                this._tabBarAddButtonRef = el;
            }, class: this.addIconButtonCss, onClick: this.onAddButtonClicked, "aria-label": this.ariaLabelValue(), title: this.ariaAddWithoutLabel }, h("bxf-icon", { type: ADD_BUTTON_ICON, state: ICON_STATE, dataTestSuffix: this.dataTestSuffix }), this.conditionalRenderingAddButtonText())));
    }
    conditionalRenderingAddButtonText() {
        return (this.addButtonLabel && (h("span", { class: ADD_ICON_SPAN }, this.addButtonLabel)));
    }
    render() {
        const containerTabsStyle = {};
        if (this.customPadding) {
            containerTabsStyle.padding = `0 ${this.customPadding}px`;
        }
        return (h("div", { key: '200717ecd6454f87f49c51000b8478c8752f0a9d', class: CONTAINER, "data-test": createSelector(this.containerHost.tagName, this.dataTestSuffix) }, h("div", { key: '481c386cbe23bd78db77eba73cbe33fd26c4edb0', class: CONTAINER_TABS, style: containerTabsStyle, ref: (el) => {
                this._tabBarContainerRef = el;
            }, role: Role.TABLIST, "aria-label": this.label }, this.renderPinnedTabs(), this.renderTabs(), this.renderAddButton(), this.renderOverflowNavigation()), this.hasBottomBorder ? (h("div", { class: BOTTOM_BORDER_DIV, ref: (el) => {
                this._tabBarBottomBorderDivRef = el;
            } })) : null));
    }
    static get watchers() { return {
        "data": ["dataChanged"],
        "isEditable": ["editableChanged"],
        "isRenameable": ["editableChanged"],
        "isDraggable": ["editableChanged"],
        "isDeletable": ["editableChanged"],
        "deletableType": ["editableChanged"],
        "isPinnable": ["editableChanged"]
    }; }
};
BxfTabBar.style = BxfTabBarStyle0;

export { BxfTabBar as bxf_tab_bar };
